import React, { createRef } from "react";
import ReactDOM from "react-dom";
import NESAHeader from "../Inc/NESAHeader";
import NESAFooter from "../Inc/NESAFooter";
import "./style.css";
import * as actions from "../../actions/index";
import { compose } from "recompose";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import warningAlert from "./warning-alert.png";
import { withRouter } from "react-router-dom";
import { history } from "../../container/History";
import InputMask from "react-input-mask";
import discountBadge from "./discount-badge.png";
import Iframe from "../HOC/iframe";
import moment from "moment";
import { CheckCircleTwoTone } from "@ant-design/icons";

import CustomPopupModal from '../Inc/customPopupModal'
import NewEagleGreetingsModal from "../Membership/NewEagleGreetingsModal";

import Papa from 'papaparse';
import {
    message,
    Alert,
    Steps,
    Button,
    Tooltip,
    Spin,
    Row,
    Col,
    Card,
    Typography,
    Popover,
    Modal,
    Form,
    Input,
    Radio,
    Checkbox,
    Select,
    Icon,
    Switch,
    Table,
    Divider,
    Popconfirm
} from "antd";
import NeedToGetShippingAddress from "./NeedToGetShippingAddress";


const FormItem = Form.Item;
const Step = Steps.Step;
const InputGroup = Input.Group;
const RadioGroup = Radio.Group;
const Option = Select.Option;
const LoadingIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
const CHASE_URL = process.env.REACT_APP_CHASE;

const GIFTED_PURCHASE = JSON.parse(process.env.REACT_APP_GIFTED_PURCHASE);
const GIFTEE_GREATINGS = JSON.parse(process.env.REACT_APP_GIFTEE_GREATINGS);

const deceasedPopup_primaryConent = "We’re sorry, but NESA memberships cannot be issued in the name of a deceased individual."
const deceasedPopup_secondaryConent = "If you have any questions or need further assistance, please contact us at NESA@scouting.org."

// const PENDING_MEMBERSHIP_TEXT = process.env.REACT_APP_PENDING_MEMBERSHIP_TEXT;
// const CONFIRM_MEMBERSHIP_TEXT = `On behalf of the Scouting America and the National Eagle Scout Association, I want to personally thank you for your generous gift purchasing a NESA membership for a qualified Eagle. Thank you for helping continue an Eagle's Scouting experience as a NESA member.`;
let BackBtn = false;
const { Text } = Typography;
const { Column, ColumnGroup } = Table
const header = ['council_number', 'applicant_first_name', 'applicant_last_name', 'applicant_address', 'applicant_address_line2', 'applicant_address_line3', 'applicant_city', 'applicant_state', 'applicant_zip', 'applicant_phone', 'applicant_date_of_birth', 'applicant_gender', 'applicant_country', 'applicant_ethnicity', 'ssn', 'email', 'eagle_scout', 'eagle_scout_date_earned', 'ypt_completion_date', 'cbc_auth_date', 'position', 'applicant_member_id', 'bl_subscription', 'org_guid', 'term_effective_date', 'term_expiration_date', 'advancepay_recharter', 'is_multiple', 'orgType', 'isform28573', 'transfer_member_id', 'paid_transfer', 'nesaAdminFee', 'applicationDate', 'alumniMembershipLevelId', 'boardReviewDate', 'eagleUnitCity', 'eagleUnitState', 'eagleUnitNumber', 'newEagle'];
let SelectedAlumni = []
const dataSource = [];

const NESA_MID = process.env.REACT_APP_NESA_MID;

let giferEmail = '';

// class MissingFieldForm extends React.Component {
//     constructor(props) {
//         super(props);
//         this.state = {
//             isShow_MissingFieldsPopup: false
//         }
//     }


//     handleSubmit_MissingField = (e) => {
//         e.preventDefault();
//         const { updateEmailValue } = this.props;
//         this.props.form.validateFieldsAndScroll((err, values) => {
//             if (!err) {
//                 this.setState({
//                     isShow_MissingFieldsPopup: false
//                 })
//                 updateEmailValue(values);
//             }
//         })
//     }

//     closeMissingFieldsPopup = () => {
//         this.setState({
//             isShow_MissingFieldsPopup: false
//         })
//     }

//     // componentDidUpdate(prevProps) {
//     //     if (prevProps.isShow_MissingFieldsPopup !== this.props.isShow_MissingFieldsPopup) {
//     //         this.setState({ isShow_MissingFieldsPopup: this.props.isShow_MissingFieldsPopup });
//     //     }
//     // }

//     render() {
//         const { getFieldDecorator } = this.props.form;
//         return (
//             <Modal
//                 className="multiple-r-modal"
//                 title={false}
//                 footer={false}
//                 visible={this.state.isShow_MissingFieldsPopup}
//                 centered
//                 onCancel={() => this.closeMissingFieldsPopup()}
//                 style={{ width: '500px' }}
//             >

//                 <Row type="flex" align="left">
//                     <Col xs={24}>
//                         <div >
//                             <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
//                                 <img src={warningAlert} width="25px" height="25px" style={{ marginRight: '10px' }} />
//                                 <span className="modal-header">Missing Information</span>
//                             </div>
//                             <div className="modal-desc" style={{ margin: '10px 0px' }}>
//                                 It appear required information is missing "Scout's Email" Please update that information in order to complete your
//                                 application process.
//                                 </div>
//                         </div>
//                     </Col>
//                 </Row>

//                 <Form onSubmit={this.handleSubmit_MissingField} className="Scout-email-form alumni-ui">

//                     <Row type="flex" align="center" className="center" style={{ textAlign: 'left' }} >
//                         <Col xs={24} sm={24} md={12} lg={12} xl={12}  >
//                             <FormItem hasFeedback label="Scout’s Email" style={{ width: '100%' }}>
//                                 {getFieldDecorator("email", {
//                                     rules: [
//                                         {
//                                             required: true,
//                                             type: "email",
//                                             message: "Enter valid email address!",
//                                         },
//                                     ],
//                                 })(<Input placeholder="Email" />)}
//                             </FormItem>
//                         </Col>
//                     </Row>



//                     <Row type="flex" align="center" justify="end">
//                         <Col xs={24} sm={24} md={24} lg={8} xl={8}>
//                             <div className="step-container " style={{ margin: '0px' }}>
//                                 <FormItem >
//                                     <Button
//                                         type="primary"
//                                         className="submit-btn"
//                                         htmlType="submit"
//                                         style={{ margin: '0px' }}
//                                     >

//                                         NEXT
//                                         </Button>
//                                 </FormItem>
//                             </div>
//                         </Col>
//                     </Row>
//                 </Form>


//             </Modal>


//         );
//     }
// }
// const MissingField = Form.create()(MissingFieldForm);




class BulkUploadForm extends React.Component {
    selectphonecountryIDRef = createRef();
    constructor(props) {
        super(props);
        this.dobInput = React.createRef();

        this.state = {
            current: 0,
            receipt_loading: false,
            userDetails: {},
            value: 1,
            TotalAmount: 0,
            SelectedMembership: 0,
            SelectedMembershipName: "",
            SelectedMembershipPrice: 0,
            EagleResults: [],
            NoResultsMatchProfile: false,
            isDeceasedPerson: false,
            showResultModal: false,
            SelectedAlumni: [],
            alteremail: 'none',
            selectedRecord: [],
            minutes: 0,
            seconds: 20,
            isAdminFee: false,
            enableReceiptMail: "Yes",
            gifter: '',
            isShow_MissingFieldsPopup: false,
            isMissingEmail: false,
            // isMissingPhoneNumber: false,
            EmailValue: '',
            existingLifePlan: false,
            yoursCountry: "616",
            memberSelectedKey: 0,
            isSingleShippingAddress: false,
            dobInputMask: '',
            scouts_BOR: '',
            showMessage:false,
            doesShowNewMemberGreetings: false,
            isApplicableForNewEagle: false,
        };
        window.showBulkReceiptComponent = this
    }

    handleEmailValueChange = (e) => {
        try {
            e.preventDefault();
            this.props.form.validateFieldsAndScroll(['email'], (err, values) => {
                if (!err) {
                    const { isMissingEmail, 
                        // isMissingPhoneNumber, 
                        selectedRecord } = this.state;
                    const { email, phone, phonecountryID } = values;

                    if (isMissingEmail) {
                        this.setState({ EmailValue: email });
                        selectedRecord.email = email;
                    }

                    // if (isMissingPhoneNumber) {
                    //     this.setState({ PhoneNumber: phone, phoneCountryId: phonecountryID });
                    //     selectedRecord.phone = phone;
                    //     selectedRecord.phoneCountryId = phonecountryID;
                    // }
                    this.setState({
                        isShow_MissingFieldsPopup: false,
                        selectedRecord
                    })
                    this.addAlumni()
                }
            })
        }
        catch (error) {
            console.log(error);
            Notification(
                'error',
                `Oops! Error occured. ${error.response.data.message}`,
            );
        }

    };

    closeNewMemberGreetingsModal = () => {
        this.setState({
            doesShowNewMemberGreetings: false,
        })
    }

    addAlumni = () => {
        this.setState({ SelectedAlumni: SelectedAlumni })
        const hasMatch = SelectedAlumni.some(obj => obj.memberId === this.state.selectedRecord.memberId);
        if (hasMatch)
            message.error('You have already added this alumni.');
        else {
            const {selectedRecord} = this.state;
            selectedRecord.needToGetShippingAddress = !(selectedRecord.isAddressExists);
            SelectedAlumni.push(this.state.selectedRecord)
        }
        this.closeResult()
        this.props.form.resetFields();
        this.setState({ scouts_DOB: '', scouts_BOR: '' }) //To clear the DOB input mask field value. AAG-1082
        // this.setState({ scouts_DOB: '' }, () => { //To clear the DOB input mask field value. AAG-1082
        //     if (this.dobInput) {
        //       this.dobInput.setInputValue('');
        //     }
        //   });
    }

    closeMissingFieldsPopup = () => {
        this.setState({
            isShow_MissingFieldsPopup: false
        })
    }
    showModalToGetIndividualsShippingAddress = () => {
        this.setState({
            doesShowModalToGetIndividualsShippingAddress: true
        })
    }

    closeModalToGetIndividualsShippingAddress = () => {
        this.setState({
            doesShowModalToGetIndividualsShippingAddress: false
        })
    }

    addRowHeader = (data, header) => {
        const headerRow = [header]; // Create an array with the header row
        return headerRow.concat(data); // Concatenate the header row with the data
    };

    InitTrans = () => {
        const current = this.state.current + 1;
        this.setState({ current });

        if(this.props.alumnibulkres) {
            this.props.actions.InitOrbitalPayments(
                this.props.alumnibulkres.totalAmountdue,
                "BULK NESA",
                NESA_MID,
                this.props.alumnibulkres,
                giferEmail,
                '',
                ''
            );
        }
    };

    // Re-runs the same Chase init call as InitTrans(), but without advancing `current` again -
    // used to retry after a failed initTransaction while already on the Payment step.
    retryInitTrans = () => {
        if(this.props.alumnibulkres) {
            this.props.actions.InitOrbitalPayments(
                this.props.alumnibulkres.totalAmountdue,
                "BULK NESA",
                NESA_MID,
                this.props.alumnibulkres,
                giferEmail,
                '',
                ''
            );
        }
    };

    generateCSV = (data, header, callback) => {

        const csvData = Papa.unparse(this.addRowHeader(data, header)); // Unparse the data with the added row header

        // Create form data
        const formData = new FormData();
        formData.append('file', new Blob([csvData], { type: 'text/csv' }), 'nesa.csv');

        this.props.actions.alumniBulkUpload(formData, giferEmail)

        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);

        // const link = document.createElement('a');
        // link.href = url;
        // link.download = 'NESA.csv';
        // link.click();
        callback(url); // Invoke the callback function with the generated URL
    };

    handleCSVData = (url) => {
        // Perform operations with the CSV file URL here

        console.log(url);
    };

    countries = () => {
        if (this.props.countries) {
            const countriesarray = [...this.props.countries].sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            return countriesarray.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.name}
                </Option>
            ));
        }

        return null;
    };

    getPhoneCode = () => {
        if (this.props.phonecode) {
            const phonecode = [...this.props.phonecode].sort((a, b) =>
                a.name.localeCompare(b.name)
            );

            return phonecode.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.name}
                </Option>
            ));
        }

        return null;
    };

    closeResult = () => {
        this.setState({
            showResultModal: false
        })
    }

    statesID = () => {
        if (this.props.allstates) {
            return this.props.allstates.map((k) => (
                <Option key={k.id} value={`${k.id}`}>
                    {k.short}
                </Option>
            ));
        }

        return null;
    };

    removeSpcialCharacters = address => {
        return address ? address.replace(/[^a-zA-Z0-9]/g, ' ') : '';
    }

    // checkApplicableForNewEagle = (eagleBOR) => {
    //     const currentDate = new Date();//AAG-1240 -  A NEW EAGLE STATUS IS NOW EXTENDED FOR A YEAR FROM THE BOR DATE.
    //     const newEagleApplicablePeriod = moment(eagleBOR).add(1, 'Year').subtract(1, 'day').format('MM/DD/YYYY');

    //     return Boolean(moment(currentDate).isSameOrAfter(eagleBOR) && moment(currentDate).isSameOrBefore(newEagleApplicablePeriod));

    // }

    checkApplicableForNewEagle = (eagleBOR) => {
        if (!eagleBOR) return false;
        
        const bor = moment(eagleBOR).startOf('day');
        const today = moment().startOf('day');
        const oneYearAgo = moment().subtract(1, 'year').startOf('day');
        
        return bor.isBetween(oneYearAgo, today, undefined, '[]');
    }

    generateSendCSV = (gifterAddressInfo) => {
        let selectedAlumnis = this.state.SelectedAlumni
        const gifter = gifterAddressInfo;
        //Today date for application date
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero if needed
        const formattedDate = `${year}-${month}-${day}`;


        let rows = selectedAlumnis.map(alumni => {
            let adminfee = this.state.isAdminFee ? 'TRUE' : 'FALSE';
            const ScoutsEmail = alumni.email ? alumni.email : null;
            const eagleCity = (alumni.eagleCity && !alumni.eagleCity.includes("***")) ? alumni.eagleCity : null;
            const eagleState = (alumni.eagleState && !alumni.eagleState.includes("***")) ? alumni.eagleState : null;
            const unitNumber = (alumni.unitNumber && !alumni.unitNumber.includes("***")) ? alumni.unitNumber : null;
            const councilNumber = '000';

            // let reviewDate = alumni.eagleBoardReviewDate ? moment(alumni.eagleBoardReviewDate).format('YYYY-MM-DD') : '';
            // let newEagle = false;
            // if (reviewDate) {
            //     // let parsedReviewDate = new Date(reviewDate);
            //     // let differenceInTime = Math.abs(parsedReviewDate.getTime() - today.getTime());
            //     // let differenceInDays = Math.floor(differenceInTime / (1000 * 3600 * 24)); // '1000' milliseconds = 1 second, '3600' seconds = 1 hour (60 seconds/minute * 60 minutes/hour), '24' hours = 1 day

            //     const isApplicableForNewEagle = this.checkApplicableForNewEagle(reviewDate);

               
            //     if (isApplicableForNewEagle) { //AAG-1240 - A NEW EAGLE STATUS IS NOW EXTENDED FOR A YEAR FROM THE BOR DATE.
            //         newEagle = true;
            //     }
            // }

            if (this.state.isSingleShippingAddress) {
                const addressLine1 = gifter.g_address_line_1 ? this.removeSpcialCharacters(gifter.g_address_line_1) : null;
                const addressLine2 = gifter.g_address_line_2 ? this.removeSpcialCharacters(gifter.g_address_line_2) : null;
                const addressLine3 = gifter.g_address_line_3 ? this.removeSpcialCharacters(gifter.g_address_line_3) : null;
                const city = gifter.g_city ? this.removeSpcialCharacters(gifter.g_city) : null;
                const stateId = gifter.g_state ? parseInt(gifter.g_state) : null;
                const zipCode = gifter.g_zip_code ? gifter.g_zip_code.toString() : null;
                const countryId = gifter.g_countryId ? parseInt(gifter.g_countryId) : null;
                const phone = (gifter.g_phone && !gifter.g_phone.includes("***")) ? gifter.g_phone.toString() : null;
        
                return [councilNumber, alumni.firstName, alumni.lastName, addressLine1, addressLine2, addressLine3, city, stateId, zipCode, phone, alumni.dob, alumni.gender, countryId, null, null, ScoutsEmail, 'TRUE', null, null, null, 713, alumni.memberId, null, 'F3A77C78-EE20-474E-9219-D53400753B29', null, null, null, null, null, null, null, null, adminfee, formattedDate, Number(alumni.membershipType), alumni.eagleBoardReviewDate, eagleCity, eagleState, unitNumber, alumni.newEagle];
            } else if (!alumni.isAddressExists) {
                const addressLine1 = alumni.addressLine1 ? this.removeSpcialCharacters(alumni.addressLine1) : null;
                const addressLine2 = alumni.addressLine2 ? this.removeSpcialCharacters(alumni.addressLine2) : null;
                const addressLine3 = alumni.addressLine3 ? this.removeSpcialCharacters(alumni.addressLine3) : null;
                const city = alumni.city ? this.removeSpcialCharacters(alumni.city) : null;
                const stateId = alumni.state ? parseInt(alumni.state) : null;
                const zipCode = alumni.zipCode ? alumni.zipCode.toString() : null;
                const countryId = alumni.countryId ? parseInt(alumni.countryId) : null;
        
                return [councilNumber, alumni.firstName, alumni.lastName, addressLine1, addressLine2, addressLine3, city, stateId, zipCode, null, alumni.dob, alumni.gender, countryId, null, null, ScoutsEmail, 'TRUE', null, null, null, 713, alumni.memberId, null, 'F3A77C78-EE20-474E-9219-D53400753B29', null, null, null, null, null, null, null, null, adminfee, formattedDate, Number(alumni.membershipType), alumni.eagleBoardReviewDate, eagleCity, eagleState, unitNumber, alumni.newEagle];
            } else {
                const phone = (alumni.phone && !alumni.phone.includes("***")) ? alumni.phone : null;
        
                return [councilNumber, alumni.firstName, alumni.lastName, null, null, null, null, null, null, phone, alumni.dob, alumni.gender, null, null, null, ScoutsEmail, 'TRUE', null, null, null, 713, alumni.memberId, null, 'F3A77C78-EE20-474E-9219-D53400753B29', null, null, null, null, null, null, null, null, adminfee, formattedDate, Number(alumni.membershipType), alumni.eagleBoardReviewDate, eagleCity, eagleState, unitNumber, alumni.newEagle];
            }
        });        
        this.generateCSV(rows, header, this.handleCSVData);
    }

    next() {
        const current = this.state.current + 1;
        this.setState({ current });
    }

    enableReceiptMail = (value) => {
        this.setState({
            enableReceiptMail: value
        })
    }

    prev() {
        const current = this.state.current - 1;
        this.setState({ current });
        // BackBtn = true;
        // const current = this.state.current - 1;
        // let length = this.state.EagleResults.length;
        // if (current == 1 && length > 1) {
        //     this.setState({
        //         current,
        //         showResultModal: true,
        //     });
        // }
    }

    componentDidMount = () => {
        this.props.actions.getallcouncils()
        this.props.actions.getNESAmembershiplevels();
        this.props.actions.getProductPrice();
        this.props.actions.getCountries();
        this.props.actions.getStates();
        this.props.actions.getEthnicities();
        this.props.actions.getPhoneCountries();
        if (this.props.location.state) {
                if (this.props.location.state.redirectedFrom === 'gift-membership') {
                    this.setState({
                        isRedirectedFromGiftMembership: true,
                    })
                }
            }
    };

    componentDidUpdate(prevProps) {
  if (
    !prevProps.regError &&
    this.props.regError &&
    this.state.receipt_loading
  ) {
    this.setState({ receipt_loading: false });

    const { errorCode, message, errorDesc } = this.props.regError;

    Modal.error({
      title: `Error ${errorCode || ""}`,
      content: (
        <div>
          <p><b>{message || "Request failed"}</b></p>
          {errorDesc && <p>{errorDesc}</p>}
        </div>
      )
    });
  }
}


    showResults = () => {
        this.setState({
            showResultModal: true
        })
    }


    handleSearchSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll(['scout_first_name', 'scout_last_name', 'dob', 'scout_eagle_unit', 'scout_eagle_council', 'BOR'], (err, values) => {
            if (!err) {
                    values.scout_dob = this.state.scouts_DOB;
                    this.props.actions.searchEagle(values);
            }
        });
    };

    handleFocus = () => {
        this.setState({ showMessage: true });
    };

    handleBlur = () => {
        this.setState({ showMessage: false });
    };

    componentWillReceiveProps = (nextprops) => {
        // InitTrans() advances `current` to the Payment step immediately on click, before
        // the Chase initTransaction call resolves. If that call fails, InitOrbitalPayments
        // dispatches a null initTransaction (as opposed to undefined on initial state) - treat
        // that as an explicit failure signal and step back so the user isn't stuck on a blank
        // Payment step; they can retry from there via the "Try Again" button in renderIframe().
        if (this.props.initTransaction !== nextprops.initTransaction) {
            if (nextprops.initTransaction === null && this.state.current === 3) {
                this.setState({ current: 2 });
            }
        }
        if ((this.props.alumnibulkres !== nextprops.alumnibulkres) && nextprops.alumnibulkres) {
            if(nextprops.alumnibulkres.length != 0){
            let selectedAlumni = this.state.SelectedAlumni
            let feeDetails = nextprops.alumnibulkres
            // Merge fees into selectedAlumni array
            selectedAlumni.forEach((user, index) => {
                if (feeDetails) {
                    feeDetails.applicants.forEach(feeDetail => {
                        if (parseInt(feeDetail.applicantMemberId) === user.memberId) {
                            selectedAlumni[index].alumniRegisrationFee = feeDetail.alumniRegisrationFee.toFixed(2)
                            selectedAlumni[index].alumniAdminFee = parseFloat(feeDetail.alumniAdminFee).toFixed(2)
                            // selectedAlumni[index].alumniShippingFee = feeDetail.alumniShippingFee.toFixed(2) // Removed S/H charges in bulk as per Matt's req on AAG-1084
                            selectedAlumni[index].amount = feeDetail.amount.toFixed(2)
                            selectedAlumni[index].discount = parseFloat(feeDetail.discount).toFixed(2)
                            selectedAlumni[index].discountDescription = feeDetail.discountDescription;
                        }
                    });
                    let current = this.state.current + 1;
                    this.setState({ current });
                    window.scrollTo(0,0);
                }
            });
            return
        }
        }

        if (this.props.nesa_reg !== nextprops.nesa_reg && !nextprops.nesa_regLoading) { //AAG-1240 - A NEW EAGLE STATUS IS NOW EXTENDED FOR A YEAR FROM THE BOR DATE.
            let nesareg = nextprops.nesa_reg ? nextprops.nesa_reg : []

            if (nesareg.length == 0 && nesareg != "error") {
                const isApplicableForNewEagle = this.checkApplicableForNewEagle(this.state.selectedRecord.eagleBoardReviewDate);
                let updateSelectedRecord = { ...this.state.selectedRecord };
                updateSelectedRecord.newEagle = isApplicableForNewEagle

                this.setState({
                    doesShowNewMemberGreetings: isApplicableForNewEagle,
                    isApplicableForNewEagle,
                    selectedRecord: updateSelectedRecord,
                 })
            }
            else {
                this.setState({
                    doesShowNewMemberGreetings: false,
                    isApplicableForNewEagle: false
                })
            }
            
            this.closeLoadingNesaReg()
        }

        if (this.props.searchedEagle !== nextprops.searchedEagle){
            if (Array.isArray(nextprops.searchedEagle)) {
                if (nextprops.searchedEagle.length < 1) this.show_NoResultsFound_Modal();
                let filterSearchedEagle;
                // if (nextprops.searchedEagle.length >= 1) {
                filterSearchedEagle = nextprops.searchedEagle.filter(each => {
                    return each.eagleBoardReviewDate != "" && each.eagleBoardReviewDate != null && each.eagleCertificationDate != "" && each.eagleCertificationDate != null && each.memberId != '' && each.memberId != null
                })
                //     } else {
                //         filterSearchedEagle = nextprops.searchedEagle
                //    }
                if (this.props.allstates) {
                    filterSearchedEagle.map(eachRec => {
                        this.props.allstates.map(item => {
                            if (item.short == eachRec.state) {
                                eachRec.stateId = item.id
                            }
                        })
                    })
                }

                let length = filterSearchedEagle.length
                //AAG-971 Remove 'Scout's Phone Number from NESA application process
                // let phoneCountryId = ""
                // let PhoneNumber = ""
                // if (length > 0 && filterSearchedEagle[0].phone.length == 13) {
                //     let getCountryShort = filterSearchedEagle[0].phone.slice(0, 3).toString();
                //     if (this.props.phonecode) {
                //         this.props.phonecode.map(code => {
                //             if (getCountryShort == code.short) {
                //                 phoneCountryId = code.id
                //             }
                //         })
                //     }
                //     PhoneNumber = filterSearchedEagle[0].phone.slice(3);
                // } else if (length > 0) {
                //     PhoneNumber = filterSearchedEagle[0].phone.replace(/ /g, '');
                // }

                if (length === 0) {
                    this.show_NoResultsFound_Modal();
                } else {
                    this.setState({ NoResultsFound: false });
                }

                if (length == 1) {
                    // const current = this.state.current + 1;
                    // this.props.actions.getProfileInfo(filterSearchedEagle[0].personGuid)
                    // this.props.actions.getAlumniEagleInfo(filterSearchedEagle[0].personGuid)
                    if (filterSearchedEagle[0].isDeceased) {
                        this.setState({
                            isDeceasedPerson: true
                        })
                    } else {
                    let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)
                    this.showResults()
                    this.props.actions.getNESARegistrations(filterSearchedEagle[0].personGuid, true);
                    this.showLoadingNesaReg()
                    filterSearchedEagle[0].dob = this.state.scouts_DOB
                    this.setState(
                        {
                            isDeceasedPerson: filterSearchedEagle[0].isDeceased,
                            personGUID: filterSearchedEagle[0].personGuid,
                            EagleResults: filterSearchedEagle,
                            selectedRecord: filterSearchedEagle[0],
                            scoutsCountry: filterSearchedEagle[0].countryId,
                            // phoneCountryId,
                            // PhoneNumber, //AAG-971 Remove 'Scout's Phone Number from NESA application process
                            getValidEagleState: getValidEagleDetails.getValidEagleState,
                            getValidEagleCity: getValidEagleDetails.getValidEagleCity
                        }
                    );
                    }
                }
                if (length > 1) {
                    this.showResults()
                    let getValidEagleDetails = this.getValidEagleStateHandler(filterSearchedEagle[0].eagleState, filterSearchedEagle[0].eagleCity)
                    filterSearchedEagle[0].dob = this.state.scouts_DOB
                    this.setState({
                        // showResultModal: true,
                        // phoneCountryId, //AAG-971 Remove 'Scout's Phone Number from NESA application process
                        // PhoneNumber,
                        selectedRecord: filterSearchedEagle[0],
                        scoutsCountry: filterSearchedEagle[0].countryId,
                        EagleResults: filterSearchedEagle,
                        personGUID: filterSearchedEagle[0].personGuid,
                        getValidEagleState: getValidEagleDetails.getValidEagleState,
                        getValidEagleCity: getValidEagleDetails.getValidEagleCity
                    })
                }
                // if (length === 0)
                //     this.show_NoResultsFound_Modal()
            }
        }

    };

    getValidEagleStateHandler = (eagleState, eagleCity) => {
        let getValidEagleState, getValidEagleCity;
        let getEagleState = this.props.allstates.filter(state => {
            return state.short == eagleState
        })
        if (getEagleState.length == 0) {
            getValidEagleState = null;
            getValidEagleCity = null
        }
        else {
            getValidEagleState = eagleState;
            getValidEagleCity = eagleCity
        }

        return { getValidEagleState, getValidEagleCity }
    }

    close_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: false
        })
        // history.push('/my-profile')
    }

    componentWillUnmount() {
        clearInterval(this.loadingInterval);
    }

    show_NoResultsFound_Modal = () => {
        this.setState({
            NoResultsFound: true
        })
    }
    SelectedMemberRecord = (record, i) => {
        //AAG-971 Remove 'Scout's Phone Number from NESA application process
        // let phoneCountryId = "", PhoneNumber = "";
        // record.dob = this.state.scouts_DOB
        // if (record.phone.length == 13) {
        //     let getCountryShort = record.phone.slice(0, 3).toString();
        //     if (this.props.phonecode) {
        //         this.props.phonecode.map(code => {
        //             if (getCountryShort == code.short) {
        //                 phoneCountryId = code.id
        //             }
        //         })
        //     }
        //     PhoneNumber = record.phone.slice(3);
        // } else {
        //     PhoneNumber = record.phone;
        // }

        let getValidEagleDetails = this.getValidEagleStateHandler(record.eagleState, record.eagleCity)

        this.setState({
            // phoneCountryId,
            // PhoneNumber, //AAG-971 Remove 'Scout's Phone Number from NESA application process
            scoutsCountry: record.countryId,
            memberSelectedKey: i,
            selectedRecord: record,
            personGUID: record.personGuid,
            getValidEagleState: getValidEagleDetails.getValidEagleState,
            getValidEagleCity: getValidEagleDetails.getValidEagleCity
        })

    }
    showLoadingReceipt = () => {
        this.setState({
            receipt_loading: true
        })
        this.loadingInterval = setInterval(() => {
            const { seconds, minutes } = this.state

            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.loadingInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    showReceipt = (RegID, response) => {

        this.setState({
            current: 4
        })

        //Today date for application date
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
        const day = String(today.getDate()).padStart(2, '0'); // Add leading zero if needed
        const formattedDate = `${month}/${day}/${year}`;

        //Gifter Receipt Email
        // const gifterGreetingMessage = `On behalf of the Scouting America and the National Eagle Scout Association, I want to personally thank you for your generous gift purchasing a NESA membership for a qualified Eagle. Thank you for helping continue an Eagle's Scouting experience as a NESA member.`
        let gifteeGreetingMessage = `Welcome NESA member! We have successfully verified your Eagle Scout Award status. Thank you for continuing your Scouting experience as a NESA member. Please expect your packet to arrive within 6 weeks.`
        let gifterMailData = {
            // "email": this.state.gifter.g_email, //ReceiptEmail,
            // "amount": response.item.amount ? parseFloat(response.item.amount) : '',
            // // "address": this.state.gifter.g_address_line_1 + ' ' + this.state.gifter.g_address_line_1 + ' ' + this.state.gifter.g_city + ' ' + this.state.gifter.g_state + ' ' + this.state.gifter.g_zip_code,
            // "date": formattedDate,
            // "purchasedBy": response.item.customer_firstname + " " + response.item.customer_lastname,
            // "billingAddress": `${response.item.customer_address ? response.item.customer_address : ''} , ${response.item.customer_address2 ? response.item.customer_address2 : ''} , ${response.item.customer_city ? response.item.customer_city : ''} , ${response.item.customer_state ? response.item.customer_state : ''} , ${response.item.customer_country ? response.item.customer_country : ''}  `,
            // "creditCardNumber": response.item.mPAN ? response.item.mPAN : '',
            // "name": this.state.gifter.g_first_name + ' ' + this.state.gifter.g_last_name,
            
            "toGifter": true,
            "transactionId": response.item.transId ? response.item.transId : '',
            "paragraph1": GIFTED_PURCHASE.PARAGRAPH1,
            "paragraph2": GIFTED_PURCHASE.PARAGRAPH2,
            "paragraph3": GIFTED_PURCHASE.PARAGRAPH3,
            "paragraph4": GIFTED_PURCHASE.PARAGRAPH4,
            "paragraph5": GIFTED_PURCHASE.PARAGRAPH5,

        }
        this.props.actions.sendNesaMail(gifterMailData)
        if (this.state.enableReceiptMail == "Yes") {
            //Giftee Receipt Email
            this.state.SelectedAlumni.forEach(alumni => {
                let addressDetails;
                if (!alumni.needToGetShippingAddress && !alumni.isAddressExists) {
                    const {addressLine1, addressLine2, addressLine3, city, state, zipCode, needToGetShippingAddress} = alumni;
                  
                    const addressParts = [
                      addressLine1 ? addressLine1.replaceAll(',', '') : '',
                      addressLine2 ? addressLine2.replaceAll(',', '') : '',
                      addressLine3 ? addressLine3.replaceAll(',', '') : '',
                      city || '',
                      state || '',
                      zipCode || '',
                    ];
                    // Filter out empty parts and join with a space
                    addressDetails = addressParts.filter(Boolean).join(' ');
                  }
                  
                let gifteeMailData = {
                    // "name": `${alumni.firstName ? alumni.firstName : ''} ${alumni.lastName ? alumni.lastName : ''} `,
                    // "address": addressDetails ? addressDetails : undefined,
                    // "email": alumni.email,
                    
                    "address": addressDetails ? addressDetails : undefined, //The address will be passed If the alumni's address was not in the DB
                    "purchasedBy": `${response.item.name ? response.item.name : ''}`,
                    "memberId" :  alumni.memberId, //The email ID and scout name gets by the ESB through the MID. (In addition, if we fail to pass the address, they also gets address details.)
                    "MembershipType": alumni.membershipType ? (alumni.membershipType == "30" ? "NESA 5Year" : "NESA Lifetime") : '',
                    //Other than the gifter's name, no CC information needs to be shown in giftee emails. To accomplish this, we remove the transaction code from the giftee mail so that only the gifter's name is displayed.
                    // "transactionId": response.item.transId ? response.item.transId : '', 
                    "paragraph1": GIFTEE_GREATINGS.PARAGRAPH1,
                    "paragraph2": GIFTEE_GREATINGS.PARAGRAPH2,
                    "paragraph3": GIFTEE_GREATINGS.PARAGRAPH3,
                    "paragraph5": GIFTEE_GREATINGS.PARAGRAPH5,
                }
                this.props.actions.sendNesaMail(gifteeMailData)
            });
        }
    }

    renderReceiptpage = () => {
        if (this.props.regstatus) {
            // if (this.props.regstatus[0].applicationStatusId == "4") {
            //     this.setState({
            //         ReceiptPara1: PENDING_MEMBERSHIP_TEXT
            //     })
            // }
            // if (this.props.regstatus[0].applicationStatusId == "21") {
            //     this.setState({
            //         ReceiptPara1: CONFIRM_MEMBERSHIP_TEXT
            //     })
            // }
            this.setState({
                current: 4
            })
        }
    }

    renderIframe = () => {
        if (this.props.initloading == true) {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Chase Payments..."
                        />
                    </Col>
                </Row>
            );
        } else if (this.props.registration_loading) {
            return (
                <Row>
                    <Col span={24}>
                        <Spin
                            indicator={LoadingIcon}
                            className="loading-state"
                            tip="Loading Please Wait..."
                        />
                    </Col>
                </Row>
            );
        } else if (this.props.initTransaction) {
            return (
                <Row className="chase-payment">
                    <Col span={24}>
                        <Iframe
                            src={`${CHASE_URL}` + this.props.initTransaction.uID}
                            height="700px"
                            width="100%"
                        />
                    </Col>
                </Row>
            );
        } else {
            return (
                <Row>
                    <Col span={24} className="centered margin-top-30">
                        <div className="margin-bottom-20">Unable to load the payment form. Please try again.</div>
                        <Button type="primary" onClick={() => this.retryInitTrans()}>Try Again</Button>
                    </Col>
                </Row>
            );
        }
    };

    showLoadingNesaReg = () => {
        this.setState({showLoadingNesaReg: true})
}
    closeLoadingNesaReg = () => {
        this.setState({showLoadingNesaReg: false})
}
closeDeceasedPersonPopup = () => {
    this.setState({isDeceasedPerson: false})
}


    renderSearchResults = () => {
        if (this.state.EagleResults.length !== 0) {
            return this.state.EagleResults.map((eagle, i) => {
                return (
                    <div
                        className={
                            this.state.memberSelectedKey == i
                                ? "eagle-results-active"
                                : "eagle-results"
                        }
                        key={i}
                        onClick={() => {
                            if (eagle.isDeceased) {
                                this.setState({
                                    isDeceasedPerson: true
                                })
                            } else {
                            this.SelectedMemberRecord(eagle, i)
                            this.props.actions.getNESARegistrations(eagle.personGuid, true);
                            this.showLoadingNesaReg()
                            }
                        }}
                    >
                        <Row>
                            <Col xs={23}>
                                <Row>
                                    <Col xs={24} md={12} lg={12} className="active-col">
                                        <span>
                                            <b>Scout Name: </b>
                                        </span>
                                        <span>

                                            {eagle.firstName} {eagle.middleName} {eagle.lastName}
                                        </span>
                                    </Col>
                                    <Col xs={24} md={12} lg={12} className="active-col">
                                        <span>
                                            <b>Member ID: </b>
                                        </span>
                                        <span> {eagle.memberId}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={12} lg={12} className="active-col">
                                        <span>
                                            <b>Board of Review Date: </b>
                                        </span>
                                        <span>

                                            {eagle.eagleBoardReviewDate
                                                ? eagle.eagleBoardReviewDate
                                                : "---"}
                                        </span>
                                    </Col>
                                    <Col xs={24} md={12} lg={12} className="active-col">
                                        <span>
                                            <b>Awarding Council: </b>
                                        </span>
                                        <span>

                                            {eagle.awardingCouncilName
                                                ? eagle.awardingCouncilName
                                                : "---"}
                                        </span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={12} lg={12} className="active-col">
                                        <span>
                                            <b>Council Unit Number: </b>
                                        </span>
                                        <span>{eagle.unitNumber ? eagle.unitNumber : "---"}</span>
                                    </Col>
                                    <Col xs={24} md={12} lg={12} className="active-col">
                                        <span>
                                            <b>Council City: </b>
                                        </span>
                                        <span> {eagle.eagleCity ? eagle.eagleCity : "---"}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={24} md={12} lg={12} className="active-col">
                                        <span>
                                            <b>Council State: </b>
                                        </span>
                                        <span> {eagle.eagleState ? eagle.eagleState : "---"} </span>
                                    </Col>
                                </Row>
                            </Col>
                            {this.state.memberSelectedKey == i ? (
                                <Col xs={1}>
                                    <i
                                        className="fa fa-check-circle margin-right-10 fa-2x SelectedRecord pointer"
                                        aria-hidden="true"
                                    ></i>
                                </Col>
                            ) : (
                                    ""
                                )}
                        </Row>
                    </div>
                );
            });
        }
    };
    format_Date = (e, field) => {
        let val = e.target.value.split("/");
        let NumExp = /[0-9]/;
        val[0] = NumExp.test(val[0])
            ? val[0].startsWith("-")
                ? val[0].replace("-", "0")
                : val[0]
            : "";
        val[1] = NumExp.test(val[1])
            ? val[1].startsWith("-")
                ? val[1].replace("-", "0")
                : val[1]
            : "";
        val = val.toString().replaceAll(",", "/");

        // console.log("val final " + val);
        // let g = this.props.form.getFieldValue('scout_dob');
        // console.log("getFieldValue " + g);
        if (field == "scout_dob") {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    scout_dob: val,
                });
            }, 0);
            this.setState({
                scouts_DOB: val,
            });
        } else if (field == "DOB") {
            setTimeout(() => {
                this.props.form.setFieldsValue({
                    dob: val,
                });
            }, 0);
            this.setState({
                scouts_DOB: val,
            });
        }
        // else if (field == "C_DATE") {
        //     setTimeout(() => {
        //         this.props.form.setFieldsValue({
        //             certificate_date: val,
        //         });
        //     }, 0)
        // }
    };
    AdminFee = (value) => {
        this.setState({
            isAdminFee: value,
        })
    }

    renderLevels = () => {
        if (this.props.nesa_levels) {
            let nesalevels = this.props.nesa_levels
            return nesalevels.map((k, index) => {
                return <Radio className='nese-level-radio' value={k.id}>{k.name.substring(5)}</Radio>
            })
        }
    }



    // setShippingAddressToState = (values) => {
    //     this.setState(prevState => ({
    //         needToGetShippingAddress: prevState.needToGetShippingAddress.map(eachAlumni => {
    //             const getMemberId = eachAlumni.memberId.toString();
    //             if (eachAlumni.memberId.toString() === getMemberId) {
    //                 return {
    //                     ...eachAlumni,
    //                     addressLine1: values[`ScoutsAddressline1-${getMemberId}`] || undefined,
    //                     addressLine2: values[`ScoutsAddressline2-${getMemberId}`] || undefined,
    //                     addressLine3: values[`ScoutsAddressline3-${getMemberId}`] || undefined,
    //                     city: values[`ScoutsCity-${getMemberId}`] || undefined,
    //                     state: values[`ScoutsState-${getMemberId}`] || undefined,
    //                     zipCode: values[`ScoutsZipcode-${getMemberId}`] || undefined,
    //                     countryId: values[`ScoutsCountryId-${getMemberId}`] || undefined,
    //                     needToGetShippingAddress: false
    //                 };
    //             }
    //             return eachAlumni;
    //         })
    //     }));
    // }

    setShippingAddressToState = (updatedShippingAddress, updatedSelectedAlumni) => {
        if (Array.isArray(updatedSelectedAlumni) && updatedSelectedAlumni.length > 0) {
            this.setState({ needToGetShippingAddress: updatedShippingAddress, SelectedAlumni: updatedSelectedAlumni })
        } else {
            this.setState({ needToGetShippingAddress: updatedShippingAddress})
        }
    };

    GotoCart = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({
                    gifter: values
                })
                giferEmail = values.g_email;
                this.generateSendCSV(values)
            }
        })
    }

    setMembershipType = (type, record) => {
        return record[`membershiptype-${record.memberId}`] = type;
    };

    onFinish = (e) => {
        e.preventDefault();
        let SelectedAlumni = [...this.state.SelectedAlumni]
        let membershiptype = SelectedAlumni.map((item) => {
            const memberId = item.memberId;
            return `membershiptype-${memberId}`;
        });
        membershiptype.push('shippingPacketoptions');
        this.props.form.validateFieldsAndScroll(membershiptype, (err, values) => {
            if (!err) {
                let checkNeedToGetShippingAddress = [];
                if (Array.isArray(this.state.needToGetShippingAddress) && this.state.needToGetShippingAddress.length > 0) {
                    checkNeedToGetShippingAddress = this.state.needToGetShippingAddress.filter(record => (record.needToGetShippingAddress && !record.isAddressExists));
                }
                if (checkNeedToGetShippingAddress.length > 0) this.showModalToGetIndividualsShippingAddress();
                else {
                    // if (this.shippingPacketForm) {
                    // this.shippingPacketForm.validateFieldsAndScroll((err2, values) => {
                    //     if (!err2) {
                    const updatedData = SelectedAlumni.map((item) => ({
                        ...item,
                        membershipType: values[`membershiptype-${item.memberId}`],
                    }));

                    const current = this.state.current + 1;
                    this.setState({ current: current, SelectedAlumni: updatedData });
                    //console.log("Form values:", values);
                }
            }
        })
        //     }
        // }
        // })
    }

    changeAlternateShippingAddress = (e) => {
            // this.setState(({isSingleShippingAddress: e == 'alternate' ? true : false})) 
            let checkNeedToGetShippingAddress;
            if (!(e.target.value == 'alternate')) {
                checkNeedToGetShippingAddress = this.state.SelectedAlumni.filter(record => record.needToGetShippingAddress && (!record.isAddressExists));
                if(checkNeedToGetShippingAddress.length > 0) this.showModalToGetIndividualsShippingAddress()
            }
            this.setState(({
                isSingleShippingAddress: e.target.value == 'alternate' ? true : false,
                needToGetShippingAddress : checkNeedToGetShippingAddress == undefined ? [] : checkNeedToGetShippingAddress
            })) 
     }

     stateInputEle = () => {
        return (
            <input
                maxLength={2}
                style={{ textTransform: "uppercase" }}
                autoComplete={"off"}
            />
        );
    };
     
    allCouncils = () => {
        if (this.props.councils && !this.props.councils_adding) {
            let councilsArray = this.props.councils.sort((a, b) => a.councilLong - b.councilLong)
            return councilsArray.map((k, index) => {
                return (
                    <option key={k.councilGuid} value={k.councilLong}>{k.councilLong}</option>
                )
                // this.forceUpdate()
            })
        }
    }

    render() {
        const { current, doesShowModalToGetIndividualsShippingAddress, needToGetShippingAddress } = this.state;
        const { minutes, seconds } = this.state;
        const { getFieldDecorator } = this.props.form;
        let futureDiscount = 0;
        let availedDiscount = 0;
        let remainingUsers = 0;
        let congratsMsg = false
        let userCount = this.state.SelectedAlumni.length
        if (userCount < 5) { //less than 5 - no discount
            remainingUsers = 5 - userCount;
            availedDiscount = 0;
            futureDiscount = 5;
        }
        else if (userCount >= 5 && userCount < 10) { // 5-9,      - 5 % discount
            remainingUsers = 10 - userCount
            congratsMsg = true
            availedDiscount = 5;
            futureDiscount = 10;
        }
        else if (userCount >= 10 && userCount < 20) {  // 10-19,   - 10 % discount
            remainingUsers = 20 - userCount
            congratsMsg = true
            availedDiscount = 10;
            futureDiscount = 18;
        } else if (userCount >= 20 && userCount <= 60) { // 20-60   - 18 % discount
            congratsMsg = true
            remainingUsers = 60 - userCount;
            availedDiscount = 18;
            futureDiscount = 25;
        } else if (userCount > 60) { // 60+       -  25 % discount
            remainingUsers = "60+";
            congratsMsg = true
            availedDiscount = 25;
        }
        

        return (
            <div>
                <NESAHeader />

                <div className="step-widget bulk-upload">
                    <div className="step-container">
                        <div className="step-background">
                            <Row type="flex" align="center" justify="center">
                                <Steps className="steps-sec" current={current}>
                                    <Step key="level" title="Eagle Search" />
                                    <Step key="your-information" title="Your Information" />
                                    <Step key="shopping-cart" title="Shopping Cart" />
                                    <Step key="payment-Summary" title="Payment" />
                                    <Step key="receipt" title="Receipt" />
                                </Steps>
                            </Row>
                        </div>
                        <div className="steps-content centered">
                            {this.state.current == 0 && (
                                <div className="centered bulk-form dashboard-container dashboard-table">
                                    <Form onSubmit={this.handleSearchSubmit} id='eaglePublicSearchForm' className="search-form alumni-ui" >
                                        <Row type="flex" justify="center" align="center">
                                            <Col sm={24} xs={24} lg={24} xl={24} className="center">
                                                <img src="../NESA.png" className="NESA-logo" />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className="welcome-text">
                                                    We’re glad you are here!
                                                </span>
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className="thank-you">
                                                    Thank you for supporting current and future Eagle Scouts
                                                    with your purchase.
                                                </span>
                                                <span className="thank-you b">
                                                    Select the eagles and membership levels you would like to purchase.
                                                </span>
                                            </Col>
                                            <Col xs={24} sm={24} md={24} lg={24} className="nesa-con" >
                                                <Row type="flex" justify="center" align="center" gutter={48} className="nesa-con-row">
                                                    <Col xs={24} sm={24} md={24} lg={24} className="welcome-nesa-padding">
                                                        <div>
                                                            <Card className="centered" title="Search for an alumni">
                                                                {/* <Row gutter={24}> */}

                                                                <Row gutter={24}>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="First Name">
                                                                            {getFieldDecorator("scout_first_name", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Enter First Name!",
                                                                                    },
                                                                                ],
                                                                            })(<Input placeholder="First Name" />)}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="Last Name">
                                                                            {getFieldDecorator("scout_last_name", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Enter Last Name!",
                                                                                    },
                                                                                ],
                                                                            })(<Input placeholder="Last Name" />)}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem
                                                                            hasFeedback
                                                                            label="Date of Birth"
                                                                            onClick={() => this.setState({ scouts_DOB_MaskChar: "-" })}
                                                                        >
                                                                            {getFieldDecorator("dob", {
                                                                                initialValue: this.state.scouts_DOB
                                                                                    ? moment(this.state.scouts_DOB).format("MM/DD/YYYY")
                                                                                    : "",
                                                                                rules: [
                                                                                    { required: true, message: "Enter Date of Birth!" },
                                                                                    {
                                                                                        pattern:/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                                                                        message: `Please enter correct format MM/DD/YYYY Pattern`,
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <InputMask
                                                                                    ref={input => this.dobInput = input}
                                                                                    style={{ background: "#f5f5f5 " }}
                                                                                    className="input-disabled ant-input"
                                                                                    mask="99/99/9999"
                                                                                    placeholder="MM/DD/YYYY"
                                                                                    alwaysShowMask
                                                                                    maskChar={this.state.scouts_DOB_MaskChar}
                                                                                    onChange={(e) => {
                                                                                        this.format_Date(e, "DOB");
                                                                                    }}
                                                                                    render={(ref, props) => (
                                                                                        <Input className="input-disabled" disabled />
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                </Row>
                                                                <Row gutter={24}>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        {/* <FormItem hasFeedback label="Eagle Unit">
                                                                            {getFieldDecorator("scout_eagle_unit")(<Input placeholder="Eagle Unit" />)}
                                                                        </FormItem> */}
                                                                        <FormItem hasFeedback label="Eagle Unit Type & Number" 
                                                                                    // validateStatus={this.state.showMessage ? 'success' : ''}
                                                                                    help={this.state.showMessage ? ( <span style={{ color: '#003f87' }}><Icon type="info-circle" /> Please enter the Eagle Unit Type and Number</span>) : ''}>
                                                                                    {getFieldDecorator("scout_eagle_unit")
                                                                                    (<Input placeholder="Eagle Unit Type & Number" onFocus={this.handleFocus} onBlur={this.handleBlur} />)}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="Eagle Council">
                                                                            {getFieldDecorator("scout_eagle_council", {
                                                                                rules: [
                                                                                    {
                                                                                        required: false,
                                                                                        message: "Enter Eagle Council!",
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <Select
                                                                                showAction={['focus', 'click']}
                                                                                showSearch
                                                                                style={{ width: '100%' }}
                                                                                placeholder="Select Scout's Eagle Council!"
                                                                                optionFilterProp="children"
                                                                                onChange={(e) => {
                                                                                    this.setState({
                                                                                        scoutsCountry: e,
                                                                                    })
                                                                                }}
                                                                                filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                                                            >
                                                                                {this.allCouncils()}
                                                                            </Select>
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem
                                                                            hasFeedback
                                                                            label="Board Of Review Date"
                                                                            onClick={() => this.setState({ scouts_DOB_MaskChar: "-" })}
                                                                        >
                                                                            {getFieldDecorator("BOR", {
                                                                                initialValue: this.state.scouts_BOR,
                                                                                rules: [
                                                                                    { required: false, message: "Enter Board Of Review Date!" },
                                                                                    {
                                                                                        pattern:/^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
                                                                                        message: `Please enter correct format MM/DD/YYYY Pattern`,
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <InputMask
                                                                                    ref={input => this.dobInput = input}
                                                                                    style={{ background: "#f5f5f5 " }}
                                                                                    className="input-disabled ant-input"
                                                                                    mask="99/99/9999"
                                                                                    placeholder="MM/DD/YYYY"
                                                                                    alwaysShowMask
                                                                                    maskChar={this.state.scouts_DOB_MaskChar}
                                                                                    onChange={(e) => {
                                                                                        this.format_Date(e, "BOR");
                                                                                    }}
                                                                                    render={(ref, props) => (
                                                                                        <Input className="input-disabled" disabled />
                                                                                    )}
                                                                                />
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                </Row>
                                                                <Row style={{ display: 'flex', justifyContent: 'center' }}>
                                                                    <Col className='xs-center sm-center' xs={14} sm={14} md={8} lg={8} xl={8}>
                                                                        <Button style={{ margin: 0, float: 'unset', width: "100%" }} htmlType='submit' loading={this.props.searching} className="width-100 membership-start pointer submit-btn">  Search </Button>
                                                                    </Col>
                                                                </Row>

                                                                {/* </Row> */}
                                                            </Card>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col span={24} className="steps-action">
                                                <Row style={{ position: "unset" }}>
                                                    <Col xs={24} sm={24} md={13} lg={13} xl={13}  >
                                                        <div className="text-result pointer"
                                                            style={{ marginTop: "55px", marginBottom: '55px' }}
                                                            onClick={() => window.location.assign('https://nesa.org/take-action/join-us/')}><i className="fa fa-lg fa-long-arrow-left margin-right-5" ></i>  Back to NESA.org/ Join</div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    </Form>
                                    {this.state.SelectedAlumni.length > 0 &&
                                        <Form onSubmit={this.onFinish} id='bulkForm'>
                                            <Row className='selected-alumni-row' gutter={48}>
                                                <div className="selected-alumni-sec">
                                                    <Card className="centered" title="Selected Alumni">
                                                        <Col xs={24} sm={24} md={24} lg={24} xl={24} className='selected-alumni-col'>

                                                            <div id='tableWidth'>
                                                                <Table bordered className='width-100' pagination={false} dataSource={SelectedAlumni} >
                                                                    <Column title="S.No" key="index" render={(text, record, index) => index + 1} />
                                                                    <ColumnGroup title="Personal Information">
                                                                        <Column title="First Name" dataIndex="firstName" key="firstName" />
                                                                        <Column title="Last Name" dataIndex="lastName" key="lastName" />
                                                                        <Column title="Member ID" dataIndex="memberId" key="MemberId" />
                                                                    </ColumnGroup>
                                                                    <ColumnGroup title="Eagle Information">
                                                                        <Column title="BoR Date" dataIndex="eagleBoardReviewDate" key="eagleBoardReviewDate" />
                                                                        <Column title="Unit No." dataIndex="unitNumber" key="unitNumber" />
                                                                        <Column title="City" dataIndex="eagleCity" key="eagleCity" />
                                                                        <Column title="State" dataIndex="eagleState" key="eagleState" />
                                                                        <Column title="Council" dataIndex="awardingCouncilName" key="awardingCouncilName" />
                                                                    </ColumnGroup>
                                                                    <Column
                                                                        title="NESA Membership"
                                                                        key="nesamembership"
                                                                        render={(text, record) => (
                                                                            <Form.Item name={record.memberId}>
                                                                                {getFieldDecorator("membershiptype-" + record.memberId, {
                                                                                    initialValue: record[`membershiptype-${record.memberId}`] != undefined ? 
                                                                                    record[`membershiptype-${record.memberId}`] : '30',
                                                                                    rules: [
                                                                                        {
                                                                                            required: true,
                                                                                            message: "Choose Membership Type!",
                                                                                        },
                                                                                    ],
                                                                                })(
                                                                                    <Radio.Group className="nese-level-radio" name="radiogroup" onChange={(e) => this.setMembershipType(e.target.value, record)} >
                                                                                        {this.renderLevels()}
                                                                                    </Radio.Group>,
                                                                                )}
                                                                            </Form.Item>
                                                                        )}
                                                                    />
                                                                    <Column
                                                                        title="Action"
                                                                        key="action"
                                                                        render={(text, record) => (
                                                                            <span>
                                                                                <Popconfirm placement="topLeft" title="Are you sure to remove this alumni?" okText="Yes" cancelText="No"
                                                                                    onConfirm={() => {
                                                                                        SelectedAlumni = SelectedAlumni.filter(obj => obj.memberId !== record.memberId);
                                                                                        this.setState({ SelectedAlumni: SelectedAlumni })
                                                                                        message.success("Alumni has been removed from your selection list.")
                                                                                    }}
                                                                                >
                                                                                    <Button type="danger" ghost>
                                                                                        <Icon type="delete" /> Delete
                                                                        </Button>
                                                                                </Popconfirm>

                                                                            </span>
                                                                        )}
                                                                    />
                                                                </Table>

                                                            </div>
                                                            <div className='m-t-20'>
                                                                <div>
                                                                    {remainingUsers > 0 &&

                                                                        <Alert message={
                                                                            <div >
                                                                                {congratsMsg &&
                                                                                    <div className="discount-congrats-text">
                                                                                        <img style={{ height: '20px' }} src={discountBadge} /> {` Congratulations: You have availed ${availedDiscount}% discount on total amount`}
                                                                                    </div>
                                                                                }
                                                                                {
                                                                                    Boolean(futureDiscount) && (
                                                                                    <span style={{ color: '#837b7b' }}>
                                                                                        <Icon type="info-circle-o" /> Discount: If you add {remainingUsers} more alumni, you will get <b> {futureDiscount}% </b> discount on total amount.
                                                                                    </span> )
                                                                                }
                                                                                <Popover content={
                                                                                    <div>
                                                                                        <span>5-9 Alumni, 5% discount</span><br />
                                                                                        <span>10-19 Alumni, 10% discount</span><br />
                                                                                        <span>20-60 Alumni, 18% discount</span><br />
                                                                                        <span>60+ Alumni, 25% discount</span><br />
                                                                                    </div>
                                                                                } title="Discount Rates" trigger="hover">
                                                                                    <span className='pointer right' style={{ color: '#52c41a' }}> <Icon type="dollar" theme="twoTone" twoToneColor="#52c41a" /> Discount Details </span>
                                                                                </Popover>
                                                                            </div>
                                                                        } type="success" />
                                                                    }
                                                                </div>
                                                            </div>

                                                        </Col>
                                                    </Card>
                                                </div>
                                            </Row>

                                            <Row className='selected-alumni-row' gutter={48}>
                                                <div className="selected-alumni-sec">
                                                    <Card
                                                        className="centered"
                                                        title="Membership Packet Shipping Information"
                                                    >

                                                        <div className='margin-10 radio-btn-overflow'>
                                                                <Form.Item >
                                                                    {getFieldDecorator('shippingPacketoptions', {
                                                                        rules: [{ required: true, message: 'Please select at least one "Shipping" option' }],
                                                                    })(
                                                                        <Radio.Group
                                                                            onChange={this.changeAlternateShippingAddress}
                                                                            value={this.state.isSingleShippingAddress == null ? null 
                                                                                : this.state.isSingleShippingAddress
                                                                                ? 'alternate' : 'primary'}
                                                                        >

                                                                                <Radio value="primary">Ship the membership packet to the individual's Eagle Scout's address listed on their record.
                                                                                </Radio>

                                                                            <div className='margin-20'>
                                                                                <Radio value='alternate'>
                                                                                    Ship membership packet to alternate "ship to" address
                                                                                </Radio>
                                                                            </div>
                                                                        </Radio.Group>
                                                                    )}
                                                                </Form.Item>
                                                            {/* <Checkbox value=''
                                                                onChange={this.changeAlternateShippingAddress}
                                                                defaultChecked={this.state.isSingleShippingAddress}
                                                            >
                                                                Ship membership packet to individuals Eagle Scout's address listed on their record.
                                                            </Checkbox>
                                                            </div>
                                                            <div className='margin-10'>
                                                            <Checkbox 
                                                            defaultChecked={this.state.isSingleShippingAddress}
                                                            onChange={this.changeAlternateShippingAddress} value='alternate'>
                                                                Ship membership packet to alternqte "ship to" address
                                                            </Checkbox> */}
                                                        </div>
                                                    </Card>
                                                </div>
                                            </Row>

                                            <div className="steps-action centered">
                                                <div>
                                                    <Row>
                                                        <Col
                                                            className="xs-center sm-center"
                                                            xs={24}
                                                            sm={24}
                                                            md={12}
                                                            lg={12}
                                                            xl={12}
                                                        >
                                                        </Col>
                                                        <Col
                                                            className="xs-center sm-center"
                                                            xs={24}
                                                            sm={24}
                                                            md={12}
                                                            lg={12}
                                                            xl={12}
                                                        >
                                                            {this.state.SelectedAlumni.length > 0 && <Button
                                                                type="primary"
                                                                className="submit-btn"
                                                                htmlType="submit"
                                                            >
                                                                Next
                                                            </Button>
                                                            }
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </Form>
                                    }

                                </div>
                            )}
                            {this.state.current == 1 && (
                                <div className="glad-sec">
                                    <Form onSubmit={this.GotoCart} className=" search-form alumni-ui">
                                        <div className="step-widget bulk-upload">
                                            <Row>
                                                <Col span={24} className="center">
                                                    <img src="../NESA.png" className="NESA-logo" />
                                                </Col>
                                                <Col span={24} className="center">
                                                    <span className="welcome-text">
                                                        We’re glad you are here!
                                            </span>
                                                </Col>
                                                <Col span={24} className="center">
                                                    <span className="thank-you">
                                                        Thank you for supporting current and future Eagle Scouts
                                                        with your purchase.
                                            </span>
                                                    <span className="thank-you b">
                                                        Please enter your information and enable transaction fee (optional) to purchase.
                                            </span>
                                                </Col>
                                                <Row>
                                                    <Col className="card-margin" xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Card className="centered" title="Your Information">
                                                            <Row
                                                                gutter={48}
                                                                style={{ marginLeft: "0px", marginRight: "0px" }}
                                                            >
                                                                <Row
                                                                    gutter={24}
                                                                    style={{ marginLeft: "0px", marginRight: "0px" }}
                                                                >
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="First Name">
                                                                            {getFieldDecorator("g_first_name", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Enter First Name!",
                                                                                    },
                                                                                ],
                                                                            })(<Input placeholder="First Name" />)}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="Last Name">
                                                                            {getFieldDecorator("g_last_name", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        min: 2,
                                                                                        message: "Enter Last Name!",
                                                                                    },
                                                                                ],
                                                                            })(<Input placeholder="Last Name" />)}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="Phone" required={String(this.state.yoursCountry) !== "616"}>
                                                                            {getFieldDecorator("g_phone", {
                                                                                rules: [
                                                                                    {
                                                                                        validator: (rule, value, callback) => {

                                                                                            const country =
                                                                                                this.props.form.getFieldValue("g_countryId");

                                                                                            if (
                                                                                                String(country) !== "616" &&
                                                                                                !value
                                                                                            ) {
                                                                                                callback("Enter Scout Phone Number!");
                                                                                                return;
                                                                                            }

                                                                                            callback();
                                                                                        }
                                                                                    },
                                                                                    {
                                                                                        min: 4,
                                                                                        max: 10,
                                                                                        message: "Enter Scout Phone Number!"
                                                                                    },
                                                                                    {
                                                                                        pattern: /^[0-9]*$/,
                                                                                        message: "Phone Number must be all numeric!"
                                                                                    }
                                                                                ],
                                                                            })(
                                                                                <Input
                                                                                    addonBefore={getFieldDecorator(
                                                                                        "g_phonecountryID",
                                                                                        {
                                                                                            initialValue: "636",
                                                                                        }
                                                                                    )(
                                                                                        <Select
                                                                                            style={{ width: 100 }}
                                                                                            ref={this.selectphonecountryIDRef}
                                                                                            onSelect={() =>
                                                                                                this.selectphonecountryIDRef.current.blur()
                                                                                            }
                                                                                        >
                                                                                            {this.getPhoneCode()}
                                                                                        </Select>
                                                                                    )}
                                                                                    placeholder="Phone"
                                                                                />
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                </Row>
                                                                <Row
                                                                    gutter={24}
                                                                    style={{ marginLeft: "0px", marginRight: "0px" }}
                                                                >
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem hasFeedback label="Email">
                                                                            {getFieldDecorator("g_email", {
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        type: "email",
                                                                                        message: "Enter valid email address!",
                                                                                    },
                                                                                ],
                                                                            })(<Input placeholder="Email" value="" />)}
                                                                        </FormItem>
                                                                    </Col>
                                                                    <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                        <FormItem label="Country">
                                                                            {getFieldDecorator("g_countryId", {
                                                                                initialValue: this.state.yoursCountry
                                                                                    ? this.state.yoursCountry
                                                                                    : "616",
                                                                                rules: [
                                                                                    {
                                                                                        required: true,
                                                                                        message: "Enter your Country!",
                                                                                    },
                                                                                ],
                                                                            })(
                                                                                <Select
                                                                                    showAction={["focus", "click"]}
                                                                                    showSearch
                                                                                    onChange={(e) => {
                                                                                        this.setState(
                                                                                            {
                                                                                                yoursCountry: e,
                                                                                            },
                                                                                            () => {
                                                                                                if (String(e) === "616") {
                                                                                                    this.props.form.setFields({
                                                                                                        g_phone: {
                                                                                                            value: this.props.form.getFieldValue("g_phone"),
                                                                                                            errors: undefined,
                                                                                                        },
                                                                                                    });
                                                                                                } else {
                                                                                                    this.props.form.validateFields(["g_phone"], {
                                                                                                        force: true,
                                                                                                    });
                                                                                                }
                                                                                            }
                                                                                        );
                                                                                    }}
                                                                                    style={{ width: "100%" }}
                                                                                    placeholder="Select a Country"
                                                                                    optionFilterProp="children"
                                                                                    filterOption={(input, option) =>
                                                                                        option.props.children
                                                                                            .toLowerCase()
                                                                                            .indexOf(input.toLowerCase()) >= 0
                                                                                    }
                                                                                >
                                                                                    {this.countries()}
                                                                                </Select>
                                                                            )}
                                                                        </FormItem>
                                                                    </Col>
                                                                    {this.state.yoursCountry == "616" ||
                                                                        this.state.yoursCountry == "" ? (
                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem hasFeedback label="Address Line 1">
                                                                                    {getFieldDecorator("g_address_line_1", {
                                                                                        rules: [
                                                                                            {
                                                                                                required: true,
                                                                                                message: "Enter Address!",
                                                                                            },
                                                                                        ],
                                                                                    })(<Input placeholder="Address Line 1" />)}
                                                                                </FormItem>
                                                                            </Col>
                                                                        ) : (
                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem
                                                                                    hasFeedback
                                                                                    label={
                                                                                        <span>
                                                                                            Address Line 1&nbsp;
                                                                                <Tooltip
                                                                                                placement="top"
                                                                                                title="Represents street address (2423 Brighton Rd; 17 Downing Street)Combine the normal 2 line address into a single address, separating the house unit from street address via comma (2423 Brighton Road, Apt. 3; 17 Downing Street, Section 7)"
                                                                                            >
                                                                                                <Icon type="info-circle-o" />
                                                                                            </Tooltip>
                                                                                        </span>
                                                                                    }
                                                                                >
                                                                                    {getFieldDecorator("g_address_line_1", {
                                                                                        rules: [
                                                                                            {
                                                                                                required: true,
                                                                                                message: "Enter Address!",
                                                                                            },
                                                                                        ],
                                                                                    })(<Input placeholder="Address Line 1" />)}
                                                                                </FormItem>
                                                                            </Col>
                                                                        )}
                                                                </Row>
                                                                <Row
                                                                    gutter={24}
                                                                    style={{ marginLeft: "0px", marginRight: "0px" }}
                                                                >
                                                                    {this.state.yoursCountry == "616" ||
                                                                        this.state.yoursCountry == "" ? (
                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem hasFeedback label="Address Line 2">
                                                                                    {getFieldDecorator("g_address_line_2", {
                                                                                        rules: [
                                                                                            {
                                                                                                required: false,
                                                                                                message: "Enter Address!",
                                                                                            },
                                                                                        ],
                                                                                    })(<Input placeholder="Address Line 2" />)}
                                                                                </FormItem>
                                                                            </Col>
                                                                        ) : (
                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem
                                                                                    hasFeedback
                                                                                    style={{ marginBottom: "0px" }}
                                                                                    label={
                                                                                        <span>
                                                                                            Address Line 2&nbsp;
                                                                                <Tooltip
                                                                                                placement="top"
                                                                                                title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)"
                                                                                            >
                                                                                                <Icon type="info-circle-o" />
                                                                                            </Tooltip>
                                                                                        </span>
                                                                                    }
                                                                                //extra="City, Territory, Postal Code, Country"
                                                                                >
                                                                                    {getFieldDecorator("g_address_line_2", {
                                                                                        rules: [
                                                                                            {
                                                                                                required: false,
                                                                                                message: "Enter Address!",
                                                                                            },
                                                                                        ],
                                                                                    })(<Input placeholder="Address Line 2" />)}
                                                                                </FormItem>
                                                                            </Col>
                                                                        )}
                                                                    {this.state.yoursCountry == "616" ||
                                                                        this.state.yoursCountry == "" ? (
                                                                            <span>
                                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                    <FormItem hasFeedback label="City">
                                                                                        {getFieldDecorator("g_city", {
                                                                                            rules: [
                                                                                                {
                                                                                                    required: true,
                                                                                                    min: 2,
                                                                                                    message: "Enter City!",
                                                                                                },
                                                                                            ],
                                                                                        })(<Input placeholder="City" />)}
                                                                                    </FormItem>
                                                                                </Col>
                                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                    <FormItem hasFeedback label="State">
                                                                                        {getFieldDecorator("g_state", {
                                                                                            rules: [
                                                                                                {
                                                                                                    required: true,
                                                                                                    message: "Enter State!",
                                                                                                },
                                                                                            ],
                                                                                        })(
                                                                                            <Select
                                                                                                getInputElement={this.stateInputEle}
                                                                                                showAction={["focus", "click"]}
                                                                                                showSearch
                                                                                                style={{
                                                                                                    width: "100%",
                                                                                                    textTransform: "uppercase",
                                                                                                }}
                                                                                                placeholder="Select a State"
                                                                                                optionFilterProp="children"
                                                                                                filterOption={(input, option) =>
                                                                                                    option.props.children
                                                                                                        .toLowerCase()
                                                                                                        .indexOf(input.toLowerCase()) >= 0
                                                                                                }
                                                                                            >
                                                                                                {this.statesID()}
                                                                                            </Select>
                                                                                        )}
                                                                                    </FormItem>
                                                                                </Col>
                                                                            </span>
                                                                        ) : (
                                                                            <span>
                                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                    <FormItem
                                                                                        hasFeedback
                                                                                        style={{ marginBottom: "0px" }}
                                                                                        label={
                                                                                            <span>
                                                                                                Address Line 3&nbsp;
                                                                                    <Tooltip
                                                                                                    placement="top"
                                                                                                    title="List the city, territory and country according to country standards (Southampton, SO53 5PD, UK; Vancouver"
                                                                                                >
                                                                                                    <Icon type="info-circle-o" />
                                                                                                </Tooltip>
                                                                                            </span>
                                                                                        }
                                                                                        extra="City, Territory, Country"
                                                                                    >
                                                                                        {getFieldDecorator("g_address_line_3", {
                                                                                            rules: [
                                                                                                {
                                                                                                    required: true,
                                                                                                    message: "Enter Address!",
                                                                                                },
                                                                                            ],
                                                                                        })(
                                                                                            <Input placeholder="Address Line 3" />
                                                                                        )}
                                                                                    </FormItem>
                                                                                </Col>
                                                                                
                                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem hasFeedback
                                                                                  label={"Postal Code"}
                                                                                >
                                                                                  {getFieldDecorator('g_zip_code' , {
                                                                                    rules: [{ required: true, max: 10, message: 'Enter ZIP Code!' }],
                                                                                  })(
                                                                                    <Input placeholder={"ZIP Code"} maxLength={10} />
                                                                                  )}
                                                                                </FormItem>
                                                                              </Col>
                                                                            </span>
                                                                        )}
                                                                </Row>
                                                                {this.state.yoursCountry == "616" ||
                                                                    this.state.yoursCountry == "" ? (
                                                                        <Row
                                                                            gutter={24}
                                                                            style={{
                                                                                marginLeft: "0px",
                                                                                marginRight: "0px",
                                                                            }}
                                                                        >
                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem hasFeedback label="ZIP Code">
                                                                                    {getFieldDecorator("g_zip_code", {
                                                                                        rules: [
                                                                                            {
                                                                                                required: true,
                                                                                                max: 5,
                                                                                                min: 5,
                                                                                                message: "Enter ZIP Code!",
                                                                                            },
                                                                                        ],
                                                                                    })(
                                                                                        <InputMask
                                                                                            // mask="*** ***" // (alpha/ numeric)
                                                                                            mask="99999" // (alpha/ numeric)
                                                                                            placeholderChar=""
                                                                                            className="ant-input"
                                                                                            render={(ref, props) => (
                                                                                                <Input placeholder="ZIP Code" />
                                                                                            )}
                                                                                        />
                                                                                    )}
                                                                                </FormItem>
                                                                            </Col>
                                                                        </Row>
                                                                    ) : null}
                                                            </Row>
                                                            <Divider orientation="left">Recipient Notification</Divider>
                                                            <Row
                                                                style={{ marginLeft: "0px", marginRight: "0px" }}
                                                                gutter={24}>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <FormItem>
                                                                        Send email notification to Eagle recipient ?
                                                                    <Checkbox.Group style={{ width: '100%' }} >
                                                                            <Row>
                                                                                <Col span={8}>
                                                                                    <Radio.Group onChange={(event) => this.enableReceiptMail(event.target.value)} value={this.state.enableReceiptMail}>
                                                                                        <Radio value="Yes">YES</Radio>
                                                                                        <Radio value="No">NO</Radio>
                                                                                    </Radio.Group>
                                                                                </Col>
                                                                            </Row>
                                                                        </Checkbox.Group>
                                                                    </FormItem>
                                                                </Col>
                                                            </Row>

                                                        </Card>
                                                    </Col>
                                                </Row>

                                                {/* <Row>
                                                <Col className="card-margin" xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Card className="centered" title="Gift Notification">
                                                        <Row
                                                            gutter={48}
                                                            style={{ marginLeft: "0px", marginRight: "0px" }}
                                                        >
                                                            <Divider orientation="left">Email Notification</Divider>
                                                            <Row
                                                                style={{ marginLeft: "0px", marginRight: "0px" }}
                                                                gutter={24}>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                    <FormItem>
                                                                        <Checkbox>Mail to Eagle's Address</Checkbox>
                                                                    </FormItem>
                                                                </Col>
                                                            </Row>

                                                            <Row
                                                                style={{ marginLeft: "0px", marginRight: "0px" }}
                                                                gutter={24}>
                                                                <Col xs={24} sm={24} md={12} lg={7} xl={7}>
                                                                    <FormItem>
                                                                        <Checkbox onChange={(e) => {
                                                                            this.setState({
                                                                                alteremail: e.target.checked ? 'inline' : 'none'
                                                                            })
                                                                        }}>Mail to Alternate Address</Checkbox>
                                                                    </FormItem>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={7} xl={7}>
                                                                    <FormItem>
                                                                        <Input size="small" style={{ 'display': this.state.alteremail }} placeholder="Email Address" />
                                                                    </FormItem>
                                                                </Col>
                                                            </Row>
                                                            <Divider orientation="left">Address Notification</Divider>
                                                            <Row
                                                                gutter={24}
                                                                style={{ marginLeft: "0px", marginRight: "0px" }}
                                                            >
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="First Name">
                                                                        {getFieldDecorator("g_first_name", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    message: "Enter First Name!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="First Name" />)}
                                                                    </FormItem>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="Last Name">
                                                                        {getFieldDecorator("g_last_name", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    min: 2,
                                                                                    message: "Enter Last Name!",
                                                                                },
                                                                            ],
                                                                        })(<Input placeholder="Last Name" />)}
                                                                    </FormItem>
                                                                </Col>
                                                                <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                    <FormItem hasFeedback label="Phone">
                                                                        {getFieldDecorator("g_phone", {
                                                                            rules: [
                                                                                {
                                                                                    required: true,
                                                                                    min: 10,
                                                                                    max: 10,
                                                                                    message: "Enter Scout Phone Number!",
                                                                                },
                                                                                {
                                                                                    pattern: new RegExp("^[0-9]*$"),
                                                                                    message:
                                                                                        "Phone Number must be all numeric!",
                                                                                },
                                                                            ],
                                                                        })(
                                                                            <Input
                                                                                addonBefore={getFieldDecorator(
                                                                                    "g_phonecountryID",
                                                                                    {
                                                                                        initialValue: "636",
                                                                                    }
                                                                                )(
                                                                                    <Select
                                                                                        style={{ width: 100 }}
                                                                                        ref={this.selectphonecountryIDRef}
                                                                                        onSelect={() =>
                                                                                            this.selectphonecountryIDRef.current.blur()
                                                                                        }
                                                                                    >
                                                                                        {this.getPhoneCode()}
                                                                                    </Select>
                                                                                )}
                                                                                placeholder="Phone"
                                                                            />
                                                                        )}
                                                                    </FormItem>
                                                                </Col>
                                                            </Row>

                                                            <Row
                                                                gutter={24}
                                                                style={{ marginLeft: "0px", marginRight: "0px" }}
                                                            >
                                                                {this.state.yoursCountry == "616" ||
                                                                    this.state.yoursCountry == "" ? (
                                                                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                            <FormItem hasFeedback label="Address Line 2">
                                                                                {getFieldDecorator("g_address_line_2", {
                                                                                    rules: [
                                                                                        {
                                                                                            required: false,
                                                                                            message: "Enter Address!",
                                                                                        },
                                                                                    ],
                                                                                })(<Input placeholder="Address Line 2" />)}
                                                                            </FormItem>
                                                                        </Col>
                                                                    ) : (
                                                                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                            <FormItem
                                                                                hasFeedback
                                                                                style={{ marginBottom: "0px" }}
                                                                                label={
                                                                                    <span>
                                                                                        Address Line 2&nbsp;
                                                                                <Tooltip
                                                                                            placement="top"
                                                                                            title="Represents a unit, number or subset of the street address (Apt. 12; Section 3; Dept. 22)"
                                                                                        >
                                                                                            <Icon type="info-circle-o" />
                                                                                        </Tooltip>
                                                                                    </span>
                                                                                }
                                                                            //extra="City, Territory, Postal Code, Country"
                                                                            >
                                                                                {getFieldDecorator("g_address_line_2", {
                                                                                    rules: [
                                                                                        {
                                                                                            required: false,
                                                                                            message: "Enter Address!",
                                                                                        },
                                                                                    ],
                                                                                })(<Input placeholder="Address Line 2" />)}
                                                                            </FormItem>
                                                                        </Col>
                                                                    )}
                                                                {this.state.yoursCountry == "616" ||
                                                                    this.state.yoursCountry == "" ? (
                                                                        <span>
                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem hasFeedback label="City">
                                                                                    {getFieldDecorator("g_city", {
                                                                                        rules: [
                                                                                            {
                                                                                                required: true,
                                                                                                min: 2,
                                                                                                message: "Enter City!",
                                                                                            },
                                                                                        ],
                                                                                    })(<Input placeholder="City" />)}
                                                                                </FormItem>
                                                                            </Col>
                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem hasFeedback label="State">
                                                                                    {getFieldDecorator("g_state", {
                                                                                        rules: [
                                                                                            {
                                                                                                required: true,
                                                                                                message: "Enter State!",
                                                                                            },
                                                                                        ],
                                                                                    })(
                                                                                        <Select
                                                                                            getInputElement={this.stateInputEle}
                                                                                            showAction={["focus", "click"]}
                                                                                            showSearch
                                                                                            style={{
                                                                                                width: "100%",
                                                                                                textTransform: "uppercase",
                                                                                            }}
                                                                                            placeholder="Select a State"
                                                                                            optionFilterProp="children"
                                                                                            filterOption={(input, option) =>
                                                                                                option.props.children
                                                                                                    .toLowerCase()
                                                                                                    .indexOf(input.toLowerCase()) >= 0
                                                                                            }
                                                                                        >
                                                                                            {this.statesID()}
                                                                                        </Select>
                                                                                    )}
                                                                                </FormItem>
                                                                            </Col>
                                                                        </span>
                                                                    ) : (
                                                                        <span>
                                                                            <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                                <FormItem
                                                                                    hasFeedback
                                                                                    style={{ marginBottom: "0px" }}
                                                                                    label={
                                                                                        <span>
                                                                                            Address Line 3&nbsp;
                                                                                    <Tooltip
                                                                                                placement="top"
                                                                                                title="List the city, territory, postal code and country according to country standards (Southampton, SO53 5PD, UK; Vancouver"
                                                                                            >
                                                                                                <Icon type="info-circle-o" />
                                                                                            </Tooltip>
                                                                                        </span>
                                                                                    }
                                                                                    extra="City, Territory, Postal Code, Country"
                                                                                >
                                                                                    {getFieldDecorator("g_address_line_3", {
                                                                                        rules: [
                                                                                            {
                                                                                                required: true,
                                                                                                message: "Enter Address!",
                                                                                            },
                                                                                        ],
                                                                                    })(
                                                                                        <Input placeholder="Address Line 3" />
                                                                                    )}
                                                                                </FormItem>
                                                                            </Col>
                                                                        </span>
                                                                    )}
                                                                {this.state.yoursCountry == "616" ||
                                                                    (this.state.yoursCountry == "" && (
                                                                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                            <FormItem hasFeedback label="ZIP Code">
                                                                                {getFieldDecorator("g_zip_code", {
                                                                                    rules: [
                                                                                        {
                                                                                            required: true,
                                                                                            // pattern: this.state.ZipCodePattern ,
                                                                                            message: "Enter ZIP Code!",
                                                                                        },
                                                                                    ],
                                                                                })(
                                                                                    <InputMask
                                                                                        // mask="******" // (alpha/ numeric)
                                                                                        // mask="99999" // (numeric)
                                                                                        placeholderChar=""
                                                                                        className="ant-input"
                                                                                        render={(ref, props) => (
                                                                                            <Input placeholder="ZIP Code" />
                                                                                        )}
                                                                                    />
                                                                                )}
                                                                            </FormItem>
                                                                        </Col>
                                                                    ))}
                                                            </Row>
                                                            {this.state.yoursCountry == "616" ||
                                                                this.state.yoursCountry == "" ? (
                                                                    <Row
                                                                        gutter={24}
                                                                        style={{
                                                                            marginLeft: "0px",
                                                                            marginRight: "0px",
                                                                        }}
                                                                    >
                                                                        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
                                                                            <FormItem hasFeedback label="ZIP Code">
                                                                                {getFieldDecorator("g_zip_code", {
                                                                                    rules: [
                                                                                        {
                                                                                            required: true,
                                                                                            max: 5,
                                                                                            min: 5,
                                                                                            message: "Enter ZIP Code!",
                                                                                        },
                                                                                    ],
                                                                                })(
                                                                                    <InputMask
                                                                                        // mask="*** ***" // (alpha/ numeric)
                                                                                        mask="99999" // (alpha/ numeric)
                                                                                        placeholderChar=""
                                                                                        className="ant-input"
                                                                                        render={(ref, props) => (
                                                                                            <Input placeholder="ZIP Code" />
                                                                                        )}
                                                                                    />
                                                                                )}
                                                                            </FormItem>
                                                                        </Col>
                                                                    </Row>
                                                                ) : null}
                                                        </Row>
                                                        <Divider orientation="left">Recipient Notification</Divider>
                                                        <Row
                                                            style={{ marginLeft: "0px", marginRight: "0px" }}
                                                            gutter={24}>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <FormItem>
                                                                    Send email notification to eagle Recipient ?
                                                                    <Checkbox.Group style={{ width: '100%' }} >
                                                                        <Row>
                                                                            <Col span={8}>
                                                                                <Checkbox value="A">Yes</Checkbox>
                                                                            </Col>
                                                                            <Col span={8}>
                                                                                <Checkbox value="B">No</Checkbox>
                                                                            </Col>
                                                                        </Row>
                                                                    </Checkbox.Group>
                                                                </FormItem>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                            </Row> */}

                                                <Col className="card-margin" span={24}>
                                                    <Card
                                                        className="centered"
                                                        title="Membership Transaction Fee"
                                                    >
                                                        <Row>
                                                            <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                                                                <div
                                                                    className="Summary-title-txt"
                                                                    style={{ fontSize: "14px" }}
                                                                >
                                                                    Optional Transaction Fee &nbsp;
                                                                <Tooltip
                                                                        placement="bottom"
                                                                        title="Please consider covering the transaction fees for this membership purchase"
                                                                    >
                                                                        <Icon type="info-circle-o" theme="twoTone" />
                                                                    </Tooltip>
                                                                </div>
                                                                {/* <div className="summary-label-txt" style={{ fontSize: '14px' }} ></div> */}
                                                            </Col>

                                                            <Col
                                                                xs={24}
                                                                sm={24}
                                                                md={12}
                                                                lg={12}
                                                                xl={12}
                                                                className="right"
                                                            >
                                                                <div className="summary-label-txt">
                                                                    <Switch checked={this.state.isAdminFee} onClick={this.AdminFee} />

                                                                </div>
                                                            </Col>
                                                        </Row>
                                                    </Card>
                                                </Col>
                                                <div className="steps-action centered">

                                                    <Col
                                                        className="xs-center sm-center"
                                                        xs={24}
                                                        sm={24}
                                                        md={12}
                                                        lg={12}
                                                        xl={12}
                                                    >
                                                        <FormItem>
                                                            <Button
                                                                type="primary"
                                                                className="back-btn"
                                                                id="backToSearch-btn"
                                                                onClick={() => this.prev()}
                                                            >
                                                                Back to Search
                                                            </Button>
                                                        </FormItem>
                                                    </Col>
                                                    <Col
                                                        className="xs-center sm-center"
                                                        xs={24}
                                                        sm={24}
                                                        md={12}
                                                        lg={12}
                                                        xl={12}
                                                    >
                                                        <Button
                                                            type="primary"
                                                            className="submit-btn"
                                                            id="goToCart-btn"
                                                            htmlType="submit"
                                                            loading={this.props.alumnibulkloading}
                                                        >
                                                            Go to Cart
                                                            </Button>
                                                    </Col>

                                                </div>

                                            </Row>

                                        </div>
                                    </Form>
                                </div>
                            )}
                            {this.state.current == 2 && (
                                this.props.alumnibulkres && (
                                    <div>
                                        <div className="step-widget bulk-upload">
                                            <Row>
                                                <Col span={24} className="center">
                                                    <img src="../NESA.png" className="NESA-logo" />
                                                </Col>
                                                <Col span={24} className="center">
                                                    <span className="welcome-text">
                                                        We’re glad you are here!
                                            </span>
                                                </Col>
                                                <Col span={24} className="center res-padding">
                                                    <span className="thank-you">
                                                        Thank you for supporting current and future Eagle Scouts
                                                        with your purchase.
                                            </span>
                                                    <span className="thank-you b">
                                                        Please confirm the NESA Membership levels to purchase.
                                            </span>
                                                </Col>
                                                <Row className="shopping-card-row">
                                                    <Col className="card-margin" xs={24} sm={24} md={24} lg={24} xl={24}>
                                                        <Card className="centered payment-card-width" title="Shopping Cart">
                                                            <Table bordered className='width-100' pagination={false} dataSource={this.state.SelectedAlumni} >
                                                                <Column title="FIRST NAME" dataIndex="firstName" key="firstName" />
                                                                <Column title="LAST NAME" dataIndex="lastName" key="lastName" />
                                                                <Column
                                                                    title="MEMBERSHIP TYPE"
                                                                    key="nesamembership"
                                                                    render={(text, record) => {
                                                                        const nesalevels = this.props.nesa_levels;
                                                                        const selectedAlumni = this.state.SelectedAlumni;
                                                                        let membershipType = null;

                                                                        selectedAlumni.forEach((Alumni) => {
                                                                            if (Alumni.memberId === record.memberId) {
                                                                                const matchedLevel = nesalevels.find((level) => Alumni.membershipType === level.id);
                                                                                if (matchedLevel) {
                                                                                    membershipType = matchedLevel.name;
                                                                                }
                                                                            }
                                                                        });

                                                                        return <span>{membershipType}</span>;
                                                                    }}
                                                                />
                                                                <Column title="MEMBERSHIP FEE" key="alumniRegisrationFee"
                                                                    render={(text, record) => {
                                                                        return <span>${record.alumniRegisrationFee} {record.discountDescription ? <span className="newEagleDescription">{record.discountDescription}</span> : ''} </span>;
                                                                    }}
                                                                />
                                                                
                                                                {this.props.alumnibulkres.totalDiscount !== 0 ?
                                                                    <Column title="DISCOUNT" key="discount"
                                                                        render={(text, record) => {
                                                                            return <span className='green' >${record.discount}</span>;
                                                                        }}
                                                                    /> :
                                                                    <Column title="DISCOUNT" key="discount"
                                                                    render={(text, record) => {
                                                                        return <span>${record.discount}</span>;
                                                                    }}
                                                                />
                                                                }
                                                                <Column title="TRANS FEE" key="alumniAdminFee"
                                                                    render={(text, record) => {
                                                                        return <span>${record.alumniAdminFee}</span>;
                                                                    }}
                                                                />
                                                                 {/* // Removed S/H charges in bulk as per Matt's req on AAG-1084 */}
                                                                {/* <Column title="S/H FEE" key="alumniShippingFee"
                                                                    render={(text, record) => {
                                                                        return <span>${record.alumniShippingFee}</span>;
                                                                    }}
                                                                /> */}
                                                                <Column title="AMOUNT" key="amount"
                                                                    render={(text, record) => {
                                                                        return <span>${record.amount}</span>;
                                                                    }}
                                                                />
                                                            </Table>
                                                            <div className='other-price'>
                                                                {/* <Row type='flex' align='middle' justify='end'>
                                                                    <Col className='right' span={4}> Sub Total </Col>
                                                                    <Col span={4}> <span className='price'> $923.00</span>  </Col>
                                                                </Row> */}
                                                                {this.props.alumnibulkres.totalDiscount != 0 &&
                                                                    <Row type='flex' align='middle' justify='end'>
                                                                        <Col className='right' span={4}> Total Discount </Col>
                                                                        <Col className='green' span={4}><span className='discount'> - ${this.props.alumnibulkres.totalDiscount.toFixed(2)}</span> </Col>
                                                                    </Row>}
                                                                {/* {
                                                                    this.props.alumnibulkres.totalAdminFee != 0 &&
                                                                    <Row type='flex' align='middle' justify='end'>
                                                                        <Col className='right' span={4}> Transaction Fee </Col>
                                                                        <Col span={4}><span className='price'>${this.props.alumnibulkres.totalAdminFee}</span></Col>
                                                                    </Row>
                                                                } */}
                                                                <Row type='flex' align='middle' justify='end'>
                                                                    <Col className='total right' span={4}> Total Amount </Col>
                                                                    <Col className='total' span={4}> <span className='price'>${this.props.alumnibulkres.totalAmountdue.toFixed(2)}</span> </Col>
                                                                </Row>
                                                            </div>
                                                        </Card>
                                                    </Col>
                                                </Row>
                                                <div className="steps-action centered">
                                                    <div>
                                                        <Row className="shopping-card-row-btn">
                                                            <Col
                                                                className="xs-center sm-center"
                                                                xs={24}
                                                                sm={24}
                                                                md={12}
                                                                lg={12}
                                                                xl={12}
                                                            >
                                                                <FormItem>
                                                                    <Button
                                                                        type="primary"
                                                                        className="back-btn"
                                                                        id="backToSearch-btn"
                                                                        onClick={() => { this.prev() }} >
                                                                        Back
                                                            </Button>
                                                                </FormItem>
                                                            </Col>
                                                            <Col
                                                                className="xs-center sm-center"
                                                                xs={24}
                                                                sm={24}
                                                                md={12}
                                                                lg={12}
                                                                xl={12}
                                                            >
                                                                <Button
                                                                    type="primary"
                                                                    className="submit-btn"
                                                                    id="goToCart-btn"
                                                                    onClick={() => this.InitTrans()}
                                                                >
                                                                    Go to Payment
                                                            </Button>
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>

                                            </Row>
                                        </div>
                                    </div>)
                            )}
                            {this.state.current == 3 && (
                                <div>
                                    <div className="step-widget bulk-upload">
                                        <Row>
                                            <Col span={24} className="center">
                                                <img src="../NESA.png" className="NESA-logo" />
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className="welcome-text">
                                                    We’re glad you are here!
                                            </span>
                                            </Col>
                                            <Col span={24} className="center">
                                                <span className="thank-you">
                                                    Thank you for supporting current and future Eagle Scouts
                                                    with your purchase.
                                            </span>
                                                <span className="thank-you b padding-btm">
                                                    Please make payment on your credit card.
                                            </span>
                                            </Col>
                                            <Row className="shopping-card-row">
                                                <Col className="card-margin payment-card-col" xs={24} sm={24} md={24} lg={24} xl={24}>
                                                    <Card className="centered payment-card-width" title="Payment Information">
                                                        <div>
                                                            <Row>
                                                                <Col span={24}>
                                                                    <div className="checkbox-card-icon-wrapper">
                                                                        <Row>
                                                                            <Col span={10}>
                                                                                <div
                                                                                    className="title-txt margin-top-10"
                                                                                    style={{ fontSize: "16px" }}
                                                                                >
                                                                                    Credit Card
                                                                        </div>

                                                                            </Col>
                                                                            <Col span={10}>
                                                                                <img src="../credit-card.png" height={40} />
                                                                            </Col>
                                                                            <Divider />
                                                                            <Spin
                                                                                tip={`Please do not close the browser until the Receipt is displayed! \n  Redirecting in ${seconds} seconds...`}
                                                                                style={{ whiteSpace: "break-spaces" }}
                                                                                spinning={this.state.receipt_loading}
                                                                            >
                                                                                {this.renderIframe()}
                                                                            </Spin>
                                                                        </Row>
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Card>
                                                </Col>
                                            </Row>
                                            <div className="steps-action centered">
                                            <div
                                                className="text-result pointer shopping-card-row"
                                                style={{ marginTop: "55px", marginBottom: "55px" }}
                                                onClick={() => {
                                                    this.prev();
                                                }}
                                            >
                                                <i className="fa fa-lg fa-long-arrow-left margin-right-5"></i>
                                                Back to Shopping Cart
                                            </div>
                                            </div>


                                        </Row>
                                    </div>
                                    {this.renderReceiptpage()}
                                </div>
                            )}
                            {this.state.current == 4 && (
                                <div>
                                    <div className="centered steps-receipt">
                                        <Row type="flex" justify='center' className='receipt-row'>

                                            <Col
                                                s={24}
                                                sm={24}
                                                md={14}
                                                lg={14}
                                                className="margin-top-30 receipt-col"
                                            >
                                                <Card
                                                    className="receipt-header"
                                                    title="National Eagle Scout Association"
                                                >
                                                    <Row
                                                        type="flex"
                                                        justify="space-between"
                                                        align="center"
                                                    >
                                                        <Col span={24} className="right">
                                                            <img src="../NESA.png" className="receipt-logo" />
                                                        </Col>

                                                        <Col className="success-msg-table">
                                                            <Table pagination={false} dataSource={this.state.SelectedAlumni} >
                                                                <Column title="FIRST NAME" dataIndex="firstName" key="firstName" />
                                                                <Column title="LAST NAME" dataIndex="lastName" key="lastName" />
                                                                <Column title="Member ID" dataIndex="memberId" key="MemberId" />
                                                                <Column
                                                                    title="MEMBERSHIP TYPE"
                                                                    key="nesamembership"
                                                                    render={(text, record) => {
                                                                        const nesalevels = this.props.nesa_levels;
                                                                        const selectedAlumni = this.state.SelectedAlumni;
                                                                        let membershipType = null;

                                                                        selectedAlumni.forEach((Alumni) => {
                                                                            if (Alumni.memberId === record.memberId) {
                                                                                const matchedLevel = nesalevels.find((level) => Alumni.membershipType === level.id);
                                                                                if (matchedLevel) {
                                                                                    membershipType = matchedLevel.name;
                                                                                }
                                                                            }
                                                                        });

                                                                        return <span>{membershipType}</span>;
                                                                    }}
                                                                />
                                                            </Table>
                                                            <Divider />

                                                            <p>{GIFTED_PURCHASE.PARAGRAPH1}</p>
                                                            <p>{GIFTED_PURCHASE.PARAGRAPH2}</p>
                                                            <p>{GIFTED_PURCHASE.PARAGRAPH3}</p>
                                                            <p>{GIFTED_PURCHASE.PARAGRAPH4}</p>

                                                            <p>
                                                            {GIFTED_PURCHASE.PARAGRAPH5}
                                                                <a href="mailto:NESA@scouting.org">
                                                                    NESA@scouting.org
                                                                </a>
                                                            </p>
                                                        </Col>
                                                        <Col span={24} className="right signature-block">
                                                            <span>Yours in Scouting</span>
                                                            <img
                                                                src='JohnStachniak_Signature.jpg'
                                                                className="director-logo"
                                                            />
                                                            <span>
                                                                <b>John Stachniak</b>
                                                            </span>
                                                            <span>
                                                                Director, National Eagle Scout Association
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </Col>
                                            <Col xs={24} sm={24} md={14} lg={14}>
                                                <Button
                                                    type="primary"
                                                    className="submit-btn"
                                                    onClick={() =>
                                                        window.location.assign("https://nesa.org/")
                                                    }
                                                >
                                                    GO HOME
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="steps-action centered">
                            {this.state.current == 0 && (
                                <div className="membership-bottom"></div>
                            )}
                            {this.state.current == 2 && (
                                <div className="membership-bottom"></div>
                            )}
                        </div>
                    </div>
                </div>
                <NESAFooter />

{/* <MissingField updateEmailValue={this.handleEmailValueChange} isShow_MissingFieldsPopup={this.state.isShow_MissingFieldsPopup} /> */}

{this.state.isShow_MissingFieldsPopup && <Modal
                    className="multiple-r-modal"
                    title={false}
                    footer={false}
                    visible={this.state.isShow_MissingFieldsPopup}
                    centered
                    onCancel={() => this.closeMissingFieldsPopup()}
                    style={{ width: '500px' }}
                >

                    <Row type="flex" align="left">
                        <Col xs={24}>
                            <div >
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <img src={warningAlert} width="25px" height="25px" style={{ marginRight: '10px' }} />
                                    <span className="modal-header">Missing Information</span>
                                </div>
                                <div className="modal-desc" style={{ margin: '10px 0px' }}>
                                    It appear required information is missing. {/* "Scout's Email" */} {/* [list missing field here]. */} Please update that information in order to complete your
                                    application process.
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Form onSubmit={this.handleEmailValueChange} className="Scout-email-form alumni-ui">
                        {/* <Col className="card-margin search-alumni" span={24}> */}
                        {/* <Card
                                className="centered"
                                title="Scout's Missing Information"
                            > */}
                        <Row gutter={24} type="flex" align="center"
                            style={{ textAlign: 'left', justifyContent:'space-evenly' , marginLeft: '0px', marginRight: '0px' }} 
                        >
                            <div className="center" style={{ display: 'flex', justifyContent:'space-evenly'}}>
                            {
                                this.state.isMissingEmail &&
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}  >
                                <FormItem hasFeedback label="Scout's Email" style={{ width: '100%' }}>
                                    {getFieldDecorator("email", {
                                        rules: [
                                            {
                                                required: true,
                                                type: "email",
                                                message: "Enter valid email address!",
                                            },
                                        ],
                                    })(<Input placeholder="Email" />)}
                                </FormItem>
                            </Col>
                            }
                            {/* {this.state.isMissingPhoneNumber &&
                            <Col xs={24} sm={24} md={12} lg={12} xl={11}  >
                                <FormItem hasFeedback
                                    label= "Scout's Phone"
                                >
                                    {getFieldDecorator(`phone`, {
                                        rules: [{ required: true, min: 10, max: 10, message: 'Enter the phone number!' },
                                        { pattern: new RegExp("^[0-9]*$"), message: 'Enter only Numeric!' }],
                                    })(
                                        <Input
                                            addonBefore={
                                                getFieldDecorator(`phonecountryID`, {
                                                    rules: [{ required: true, message: 'Select Phone Country ID' }],
                                                })(
                                                    <Select style={{ width: 100 }} 
                                                    // onChange={(val) => { this.getUpdatedPhoneKey(k, val) }}  
                                                    >
                                                        {this.getPhoneCode()}
                                                    </Select>
                                                )
                                            }
                                            placeholder="Phone"
                                            // onChange={() => { this.getUpdatedPhoneKey(k) }}
                                        />
                                    )}
                                </FormItem>
                            </Col>
                            }  */}
                            </div>
                        </Row>



                        <Row type="flex" align="center" justify="end">
                            <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                                <div className="step-container " style={{ margin: '0px' }}>
                                    <FormItem >
                                        <Button
                                            type="primary"
                                            className="submit-btn"
                                            htmlType="submit"
                                            style={{ margin: '0px' }}
                                        //   onClick={() => {}}
                                        >

                                            NEXT
                                        </Button>
                                    </FormItem>
                                </div>
                            </Col>
                        </Row>
                        {/* </Card> 
                         </Col>  */}
                    </Form>


                </Modal>
                } 

                {/* {this.state.doesShowModalToGetIndividualsShippingAddress && <Modal
                    className="multiple-r-modal"
                    title={false}
                    footer={false}
                    closable={false}
                    visible={this.state.doesShowModalToGetIndividualsShippingAddress}
                    centered
                    onCancel={() => this.closeModalToGetIndividualsShippingAddress()}
                    style={{ width: '500px' }}
                >

                    <Row type="flex" align="left">
                        <Col xs={24}>
                            <div >
                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                                    <img src={warningAlert} width="25px" height="25px" style={{ marginRight: '10px' }} />
                                    <span className="modal-header">Missing Information</span>
                                </div>
                                <div className="modal-desc" style={{ margin: '10px 0px' }}>
                                It appears the required shipping address information is missing for the following individuals: Please provide that information in order to complete your
                                    application process.
                                </div>
                            </div>
                        </Col>
                    </Row>
                     
                    <Row type="flex" align="center">
                            <div className="step-container margin-top-20 record-found-select-btn">
                            <Form onSubmit={this.handleShippingAddressInfo} className="IndividualsShippingAddress-form alumni-ui" style={{ width: '100%' }}>
                                <Row>
                                    <Col className="card-margin" span={24}>
                                        {this.state.needToGetShippingAddress.map(eachAlumni => {
                                            if ((!eachAlumni.countryId) || eachAlumni.countryId.includes("***") || eachAlumni.countryId.toString() == '616' || eachAlumni.countryId == '')
                                                return  this.render_USAAddressForm(eachAlumni);
                                                else return this.render_nonUSA_address(eachAlumni);
                                        })}
                                    </Col>
                                </Row>

                                <Row type='flex' style={{ justifyContent: 'end', alignItems: 'center' }}>
                                    <Col className='xs-center sm-center' xs={24} sm={24} md={24} lg={5} xl={5}>
                                        <div className='step-container margin-top-20' >
                                            <Button type="primary" className='back-btn' style={{ fontSize: '13px', width: '100%' }} onClick={() => this.closeModalToGetIndividualsShippingAddress()}>CANCEL</Button>
                                        </div>
                                    </Col>
                                    <Col xs={24} sm={24} md={24} lg={5} xl={5} offset={2}>
                                        <div className='step-container margin-top-20' >
                                            <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} htmlType='submit'>SUBMIT</Button>
                                        </div>
                                    </Col>
                                </Row>

                                </Form>
                            </div>
                    </Row>


                </Modal>
                } */}
                {doesShowModalToGetIndividualsShippingAddress && <NeedToGetShippingAddress 
                    doesShowModalToGetIndividualsShippingAddress
                    SelectedAlumni = {this.state.SelectedAlumni}
                    needToGetShippingAddress = {this.state.needToGetShippingAddress}
                    closeModalHandler = {this.closeModalToGetIndividualsShippingAddress}
                    setShippingAddressToStateHandler = {this.setShippingAddressToState}

                    // render_USAAddressFormHandler = {this.render_USAAddressForm}
                    // render_nonUSA_addressHandler = {this.render_nonUSA_address}
                /> }


                <Modal
                    centered
                    className='ExistingLifeTimePlanModal'
                    visible={this.state.existingLifePlan}
                    closable={false}
                    footer={
                        <Button key="submit" type="primary" className='RedirectExistingLifePlan'
                            onClick={() => this.setState({ existingLifePlan: false })}>
                            Close
                        </Button>
                    }
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>

                        <div className='Existing-Lifeplan-Info'>
                            <span className='modal-desc'>You already have an existing NESA Lifetime plan. </span>
                        </div>
                    </div>
                </Modal>
                <Modal
                    className='No-records-Found-model'
                    style={{ width: '600px' }}
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsFound}
                    centered
                    onCancel={() => this.close_NoResultsFound_Modal()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            Missing Information
                        </div>

                        {/* <div className='margin-bottom-20'> Whoops! We found the Scout but there wasn't any Eagle Scout information associated with them.  Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Eagle Scout council for further assistance.</div> */}

                        <div className='margin-bottom-20'> Whoops! it appears there is critical information regarding First Name, Last Name or Date of Birth, missing from your Eagle Scout record. </div>
                        
                        {/* <div style={{color: ' #cc0033', marginBottom: '10px'}}>
                            Firstname, Lastname, Date of Birth
                        </div>
                        <div> please contact your Eagle Scout council for further assistance.</div>
                        <div style={{backgroundColor: "#fce4e4", border: '2px solid #fcc2c3', padding: '10px 20px', margin: '10px 0px', color: ' #cc0033'}}>
                            Missing or incomplete ID records in Akela (the master membership database)
                        </div> */}

                        {/* <div> Note: The missing information would identify the missing or incomplete information needed to complete a NESA application </div>  */}
                        <div> Please contact your Eagle Scout council to update your Eagle information. </div>
                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.close_NoResultsFound_Modal();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className='No-records-match-myMrofile-model'
                    title={false}
                    footer={false}
                    visible={this.state.NoResultsMatchProfile}
                    centered
                    onCancel={() => this.closeNorecordsMatchProfile()}
                >
                    <div className="center">
                        <div>
                            <img src={warningAlert} width="40px" height="40px" />
                        </div>
                        <div className='No-Results-Match-Pro'>
                            No Results Match Profile
                        </div>

                        <div className='margin-bottom-20'> Whoops! It appears no current Eagle Scout record matches your Eagle Scout information. Please confirm the Eagle Scout MemberID and try again.</div>
                        <div>Alternatively, please contact the Scout's Eagle Scout council for further assistance.</div>

                        <Row type='flex' style={{ justifyContent: 'center', alignItems: 'center' }}>
                            <Col className='xs-center sm-center' xs={9} sm={9} md={7} lg={7} xl={7}>
                                <div className='step-container margin-top-20' >
                                    <Button type="primary" className='submit-btn' style={{ margin: 0, fontSize: '13px', width: "100%" }} onClick={() => {
                                        this.closeNorecordsMatchProfile();
                                    }} htmlType='submit'>CLOSE </Button>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <Modal
                    className="multiple-r-modal nesa-record-found"
                    title={false}
                    footer={false}
                    visible={this.state.showResultModal}
                    centered
                    onCancel={() => this.closeResult()}
                >
                    <Row type="flex" align="left">
                        <Col xs={24}>
                            <div>
                                <span className="modal-header">{this.state.showLoadingNesaReg ? "Fetching Records!" : "Records Found!"}</span>
                                <span className="modal-desc">
                                    {this.state.showLoadingNesaReg ? "Fetching records!, please wait..." : "records were found, please select one."}
                                </span>
                            </div>
                        </Col>
                    </Row>
                    {this.state.showLoadingNesaReg ? <Row>
                        <Col span={24}>
                            <Spin
                                indicator={LoadingIcon}
                                className="loading-state"
                                tip="Please wait..."
                            />
                        </Col>
                    </Row>
                        : <div>

                    {this.renderSearchResults()}

                    <Row type="flex" align="center" className="center">
                        <Col xs={24} sm={24} md={24} lg={8} xl={8}>
                            <div className="step-container margin-top-20 record-found-select-btn">
                                <Button
                                    type="primary"
                                    className="submit-btn record-found-submit-btn"
                                    onClick={() => {

                                        if (this.props.nesa_reg && this.props.nesa_levels) {
                                            let haveLifeTime = undefined;
                                            let nesareg = this.props.nesa_reg ? this.props.nesa_reg : []
                                            let nesalevels = this.props.nesa_levels ? this.props.nesa_levels : [];

                                            if (nesareg.length != 0 && nesalevels.length != 0 && nesareg != "error") {
                                                haveLifeTime = nesareg.find(item => item.programId.toString() == '32')
                                            }
                                            if (haveLifeTime) {
                                                this.setState({ existingLifePlan: true })
                                            }
                                            else {
                                                const selectedRecord = this.state.selectedRecord;
                                                const isMissingEmail = !selectedRecord.email;
                                                // const isMissingPhoneNumber = !selectedRecord.phone;


                                                // if (isMissingEmail 
                                                //     // || isMissingPhoneNumber
                                                //     ) {
                                                    if (isMissingEmail) {
                                                        this.setState({
                                                            isShow_MissingFieldsPopup: true,
                                                            isMissingEmail,
                                                            // isMissingPhoneNumber,
                                                        });
                                                    } else {
                                                        this.addAlumni();
                                                    }
                                                // }
                                            }

                                            this.closeResult()
                                        }
                                    }
                                    }
                                >
                                    SELECT
                                </Button>
                            </div>
                        </Col>
                    </Row>
                        </div>}
                </Modal>

                {this.state.doesShowNewMemberGreetings && 
                    <NewEagleGreetingsModal 
                        doesShowNewMemberGreetingsProps={this.state.doesShowNewMemberGreetings} 
                        closeNewMemberGreetingsModalHandler={this.closeNewMemberGreetingsModal} 
                    />
                }

                <CustomPopupModal 
                doesShowPopup={this.state.isDeceasedPerson} 
                closePopup={this.closeDeceasedPersonPopup} 
                popupTitle={"Invalid Membership Purchase"} 
                popupPrimaryContent={deceasedPopup_primaryConent}
                popupSecondaryContent={deceasedPopup_secondaryConent} 
                />
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        loggingIn: state.authenticationReducer.loggingIn,
        timeout: state.authenticationReducer.timeout,
        initloading: state.chasepaymentreducer.loading,
        initTransaction: state.chasepaymentreducer.initTransaction,
        profile_loading: state.profilereducer.loading,
        profile_info: state.profilereducer.profileinfo,
        productprice: state.productpricereducer.productprice,
        productprice_loading: state.productpricereducer.loading,
        ethnicities_loading: state.ethnicitiesreducer.loading,
        ethnicities: state.ethnicitiesreducer.ethnicities,
        nesa_levels_loading: state.nesalevelsreducer.loading,
        nesa_levels: state.nesalevelsreducer.levels,
        registration_loading: state.giftmembershipreducer.loading,
        registered: state.giftmembershipreducer.response,
        allstates: state.allstatesreducer.states,
        countries: state.countriesreducer.countries,
        phonecode: state.phonecountrycodereducer.code,
        loading: state.giftmembershipreducer.loading,
        response: state.giftmembershipreducer.response,
        regstatus: state.regstatusreducer.status,
        searching: state.eagleSearchReducer.searching,
        searchedEagle: state.eagleSearchReducer.eagle,
        alumnieagleinfo: state.alumnieagleinforeducer.eagleinfo,
        alumnieagleinfo_loading: state.alumnieagleinforeducer.loading,
        applingPromocode: state.promocodereducer.loading,
        PromocodeAdded: state.promocodereducer.response,
        promoCode: state.promocodereducer.promoCode,
        PromocodeRemoved: state.promocodereducer.removedPromoAmount,
        PromocodeError: state.promocodereducer.error,
        creatingPayments: state.PaymentsCreateReducer.loading,
        createdPayments: state.PaymentsCreateReducer.response,
        nesa_reg: state.nesaregistrationreducer.reg,
        nesa_regLoading: state.nesaregistrationreducer.loading,
        shoppingCartList: state.shoppingCartReducer.response,
        alumnibulkloading: state.alumnibulkuploadreducer.loading,
        alumnibulkres: state.alumnibulkuploadreducer.response,
        councils: state.councilsreducer.councils,
        councils_adding: state.councilsaddreducer.loading,
        regError: state.regstatusreducer.regError,
    };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(actions, dispatch) };
}

const NESABulkUpload = Form.create()(BulkUploadForm);

export default connect(mapStateToProps, mapDispatchToProps)(NESABulkUpload);


// WEBPACK FOOTER //
// ./src/components/BulkUpload/alumni.js